import React from 'react';
import { Button, Divider } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Link as RouterLink } from 'react-router-dom';

import CarImg from '../images/hero/HeroRightImages/carImg.png';
import EngineIcon from '../images/hero/HeroRightImages/engineIcon.png';
import CarLoanIcon from '../images/hero/HeroRightImages/carLoanIcon.png';
import CarPaintIcon from '../images/hero/HeroRightImages/carPaintIcon.png';
import FairPriceIcon from '../images/hero/HeroRightImages/fairPriceIcon.png';
import ScannerIcon from '../images/hero/HeroRightImages/scannerIcon.png';
import WatchImg from '../images/hero/HeroRightImages/watchImg.png';

import AiDrivenLogo from '../../assets/gradeIcons/aiDrivenEngine.png';
import OBDScanner from '../../assets/gradeIcons/OBDScanner.png';
import UnbiasedCustomer from '../../assets/gradeIcons/unbiasedCustomer.png';

import one from '../images/queryComponent/oneICon.png';
import two from '../images/queryComponent/twoIcon.png';
import three from '../images/queryComponent/threeIcon.png';
import roadsideAssist from '../numberIcons/roadsideAssist.png';
import cities from '../numberIcons/cities.png';
import customerSupport from '../numberIcons/customerSupport.png';
import kilometer from '../numberIcons/kmDriven.png';
import warranty from '../numberIcons/warranty.png';
import inspected from '../numberIcons/inspected.png';
import recomended from '../../assets/images/recommended.png';

import Hyderabad from '../../assets/icons/cityIcons/charminar.png';
import Bengaluru from '../../assets/icons/cityIcons/vidhana-soudha.png';
import Pune from '../../assets/icons/cityIcons/shaniwar-wada.png';
import Chandigarh from '../../assets/icons/cityIcons/open-hand-monument.png';
import Mumbai from '../../assets/icons/cityIcons/india-gate.png';
import Chennai from '../../assets/icons/cityIcons/chennai-central-railway-station.png';
import Delhi from '../../assets/icons/cityIcons/gateway-of-india.png';
import Lucknow from '../../assets/icons/cityIcons/bara-imambara.png';

export const IndiaContent = {
  headerPage: {
    menuItems: (
      <>
        <li>
          <a aria-label="" href="/in#inspection-plans">
            Inspection Plans
          </a>
        </li>
        <li>
          <a aria-label="" href="/in#how-it-works">
            How it works
          </a>
        </li>

        <li>
          <a aria-label="" href="/in#why-wisedrive">
            ⁠⁠Why Wisedrive
          </a>
        </li>
        <li>
          <a aria-label="" href="/in#contact-us">
            Contact us
          </a>
        </li>
      </>
    ),
  },
  heroPage: {
    headLine: (
      <div className="hero-headline">
        <img loading="lazy" src={CarImg} width="30px" alt="Car Image" />
        <p>Buying Used Car ?</p>
      </div>
    ),
    header: (
      <h2>
        Get Your Car Inspected First,
        <span style={{ color: 'red' }}>
          <br /> No Regrets Later!
        </span>
      </h2>
    ),
    subPoints: [
      'Avoid Costly Repairs',
      'Get Genuine Car Condition',
      'Zero Risk Purchase',
      'Trusted Expert Check',
    ],
    btnText: 'Book Inspection',
    cardTitles: [
      {
        color: '#003cc5',
        content: (
          <>
            <h4>200+</h4>
            <p style={{ color: 'white' }}>Check points covered</p>
          </>
        ),
      },
      {
        content: (
          <>
            <img loading="lazy" src={EngineIcon} alt="" />
            <p>Engine & Transmission</p>
          </>
        ),
      },
      {
        content: (
          <>
            <img loading="lazy" src={CarPaintIcon} alt="" />
            <p>Dent & Paint Check</p>
          </>
        ),
      },
      {
        content: (
          <>
            <img loading="lazy" src={ScannerIcon} alt="" />
            <p>Advanced OBD2 Scan</p>
          </>
        ),
      },
      {
        content: (
          <>
            <img loading="lazy" src={CarLoanIcon} alt="" />
            <p>Finance and RTO Check</p>
          </>
        ),
      },
      {
        content: (
          <>
            <img loading="lazy" src={FairPriceIcon} alt="" />
            <p>Fair Price Suggestion</p>
          </>
        ),
      },
    ],
    leadForm: (
      <>
        <h6
          style={{
            color: '#e64a19',
            fontFamily: 'matterSemiBold',
            textAlign: 'center',
          }}
        >
          Don't Risk your hard Earned money -{' '}
          <span style={{ color: '#003cc5' }}>Talk to us</span>
        </h6>
      </>
    ),
    leadFormBtntxt: 'Request Call Back',
    leadFormDisclaimer:
      ' By contacting us, you agree to our terms of service and privacy policy',
    rightFooter: (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignContent: 'center',
          alignItems: 'center',
        }}
      >
        <p
          style={{
            background: '#ffea5b',
            display: 'flex',
            gap: '10px',
            padding: '2px 11px',
            textAlign: 'center',
            marginBottom: '10px',
            // width: '70%',
          }}
        >
          <img loading="lazy" src={WatchImg} alt="" width="30px"></img> Get
          Inspection Report in 2 Hrs*
        </p>
        <p className="hero-right-footer-p">
          150,000 customers got their cars inspected by us and got saved from
          purchasing accident, flodded and Engine Repair cars
        </p>
        <p className="hero-right-footer-p">
          <strong style={{ color: 'red' }}>
            Unbiased 3<sup>rd</sup> part inspection assured peace of mind while
            buying used cars!!
          </strong>
        </p>
        {/* <p className="hero-right-footer-p">
          Our expert inspections have saved customers <strong>INR 260 </strong>
          crore by preventing costly mistakes on cars with hidden engine faults
          and post purchase repairs.
        </p>
        <p className="hero-right-footer-p">
          <strong style={{ color: 'red' }}>
            Don't risk your hard-earned money - get your used car inspected
            today!
          </strong>
        </p> */}
      </div>
    ),
    rightFooterHero: (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignContent: 'center',
          alignItems: 'center',
        }}
      >
        <p className="hero-right-footer-p">
          Our expert inspections have saved customers <strong>INR 260 </strong>
          crore by preventing costly mistakes on cars with hidden engine faults
          and post purchase repairs.
        </p>
        <p className="hero-right-footer-p">
          <strong style={{ color: 'red' }}>
            Don't risk your hard-earned money - get your used car inspected
            today!
          </strong>
        </p>
      </div>
    ),
  },
  planDetails: {
    header: (
      <div className="inspection-header-container">
        <div>
          <h2 className="inspection-header">
            We've covered everything to protect your car.
          </h2>
          <h2 className="inspection-header-red">
            200+ Check Points Inspection.
          </h2>
        </div>
        <div>
          <img
            loading="lazy"
            src={recomended}
            alt=""
            className="logo-web"
          ></img>

          <div className="mbl-View-only">
            <img
              loading="lazy"
              src={recomended}
              alt=""
              className="recomended-img"
            ></img>
            <RouterLink
              style={{
                color: '#003cc5',
                fontSize: '18px',
                border: '1px solid',
                borderColor: '#003cc5',
                padding: '5px',
                borderRadius: '6px',
              }}
              target="_blank"
              to={'/sample-report'}
            >
              <p
                style={{
                  color: 'rgb(0, 60, 197)',
                  fontFamily: 'matterThin',
                  fontSize: '12px',
                  paddingLeft: '0px !important',
                  paddingTop: '0px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                }}
              >
                Sample Report
                <OpenInNewIcon fontSize="small" />
              </p>
            </RouterLink>
          </div>
        </div>
      </div>
    ),
    currency: '₹',
    noteTaxes: 'Incl. of all taxes',
    infoNote:
      'Inspection reports will be sent in Whatsapp to your registered mobile used at the time of booking.',
    inspectionCardsArray: [
      {
        header: 'Physical / Manual Inspection',
        checkPoints: '135',
        inspectionItems: [
          'Engine & Transmission Check',
          'Electrical Parts Check',
          'Mechanical Parts Check',
          'Interior & Exterior Check',
        ],
        additionalBenifits: {
          header: 'Additional Benefits',
          data: [
            'Flood Vehicle Check, Major engine repair check',
            'Battery function check, Odometer Tampering Check',
            'Braking System, Fuel System Check',
          ],
        },
      },

      {
        header: 'Advanced OBD2 Scanner Test',
        checkPoints: '76',
        inspectionItems: [
          'Engine Control Module (ECM)',
          'Transmission Control Module ',
          'Body Control Module (BCM)',
          'Fault Code check and Analysis ',
        ],
        additionalBenifits: {
          header: 'Additional Benefits',
          data: [
            'Engine failure probability Analysis, Transmission Failure Probability Analysis',
            'Stability driving check at high speeds using Advanced OBD-2 scanner',
            'Expensive Repair prevention check',
          ],
        },
      },
      {
        header: 'RTO & Police Verification',
        checkPoints: '29',
        inspectionItems: [
          'Loan and Insurance Check',
          'Traffic Fines & Blacklist Check',
          'PUC and RC Validity Check',
          'Owners & Vehicle Info Check',
        ],
        additionalBenifits: {
          header: 'Additional Benefits',
          data: [
            'Loan NOC Check, Insurance Expiry Check',
            'Blacklist Status Check',
            'Fraud data and RC Document data verification with Vaahan Database',
          ],
        },
      },
      {
        header: 'Additional Technical Support',
        checkPoints: '76',
        inspectionItems: [
          'Fair Price Estimate',
          'Repair Estimate',
          'Expert Mechanic Advice',
          'Extended Warranty up to 2 years',
        ],
      },
    ],
    partPaymentAmount: 500,
    partialBtnText: 'Pay ₹ 500 Advance',

    btnBookInspection: 'Book Inspection',
    sampleBtnText: 'Sample Report',
    steps: [
      'Register With Mobile no.',
      'Enter Car Details',
      'Select City For Inspection',
      'Verify Payment Details',
    ],
    formHeader: (
      <>
        Unlocking Standard
        <br /> Car Inspection
      </>
    ),
    errorName: 'Please enter name',
    labelName: 'Name',
    errorMobile: 'Please enter number',
    errorCity: 'Please Select city',
    labelMobile: 'Mobile Number',
    otpSuccessMsg: 'OTP sent via SMS to your mobile number',
    resendOtpLbl: 'Resend OTP',
    sendOtpLbl: 'Send OTP',
    entrrOtpLbl: 'Enter OTP',
    entrrOtpErrorLbl: 'Please Enter Valid OTP',
    verifyOtpBth: 'Verify OTP',
    otpNote: (
      <>
        By contacting us, you agree to our{' '}
        <RouterLink
          style={{
            color: '#003cc5',
            padding: '5px',
            borderRadius: '6px',
          }}
          target="_blank"
          to={'/in/inspection-terms-and-conditions'}
        >
          <strong>Terms of service</strong> and <strong>Privacy Policy</strong>
        </RouterLink>
      </>
    ),
    registerHeader: 'Enter Car Registration Number',
    searchBtn: 'SEARCH',
    carMakeLbl: 'Make',
    carModelLbl: 'Model',
    carMfYearLbl: 'Manufacturing Year',
    carTypeLbl: 'Type',
    carColorLbl: 'Color',
    confirmBtn: 'Yes, Confirm Car',
    skipBtn: 'Skip To Payment',
    cityIconArray: [
      {
        name: 'Bengaluru',
        icon: Bengaluru,
      },
      {
        name: 'Hyderabad',
        icon: Hyderabad,
      },
      {
        name: 'Pune',
        icon: Pune,
      },
      {
        name: 'Mumbai',
        icon: Mumbai,
      },
      {
        name: 'Delhi',
        icon: Delhi,
      },

      {
        name: 'Chennai',
        icon: Chennai,
      },
    ],
    selectTimeLbl: 'Select Time',
    selectDateLbl: 'Select Date',
    cityLbl: 'City',
    addressLbl: 'Enter Inspection Address',
    confirmInspectionBtn: 'Confirm Inspection',
    payHeadr: 'Summary',
    pkgAmtLbl: 'Package Amount',
    inspCurrencyLbl: ' Inspection x ₹',
    totalAmtLbl: 'Total Amount',
    partialBtnNote:
      'Balance amount to be paid post completion of your car inspection',
    fullBtnText: 'Pay Full Amount',
    fullBtnNote: (
      <>
        By selecting full Payment, you agree to our{' '}
        <RouterLink
          style={{
            color: '#003cc5',
            padding: '5px',
            borderRadius: '6px',
          }}
          target="_blank"
          to={'/in/inspection-terms-and-conditions'}
        >
          <strong>Terms of service</strong> and <strong>Privacy Policy</strong>
        </RouterLink>
      </>
    ),
    termsTxt: (
      <>
        By Proceeding, I understand and agree with the{' '}
        <RouterLink
          style={{
            color: '#003cc5',
            padding: '5px',
            borderRadius: '6px',
          }}
          target="_blank"
          to={'/in/inspection-terms-and-conditions'}
        >
          <strong>Terms of service</strong> and <strong>Privacy Policy</strong>
        </RouterLink>
        of Wisedrive Technologies Pvt Ltd
      </>
    ),
    secureLbl: 'Payments secured by',
    whatsappFooterTxt: (
      <>
        Say hi on{' '}
        <span
          style={{
            fontSize: '16px',
            fontFamily: 'matterBold',
          }}
        >
          Whatsapp at 73380 73380{' '}
        </span>{' '}
        for any queries from 9am - 7pm Mon - Sat.
      </>
    ),
    brandsCovered: 'Brands Covered',
    brandCoveredHeader: 'Brands Covered in each inspection package',
    brandsCoveredNote:
      'All Car Types like hatchback, Sedan, MUV, MPV, SUV are covered in every brand',
    standardLbl: 'Standard',
    luxaryLbl: 'Luxury',
    brandsStandardArray: [
      'MARUTHI SUZUKI',
      'HYUNDAI',
      'HONDA',
      'KIA',
      'TOYOTA',
      'VOLKSWAGEN',
      'SKODA',
      'RENAULT',
      'NISSAN',
      'MAHINDRA',
      'TATA MOTORS',
      'FORD',
      'FIAT',
      'DATSUN',
      'MISTUBISHI',
      'Chery',
      'Isuzu',
      'Mazda',
      'Mitsubishi',
      'Perodua',
      'Proton',
      'Peugeot',
    ],
    brandsLuxuryArray: [
      'MERCHEDES BENZ',
      'BMW',
      'AUDI',
      'VOLVO',
      'FERRARI',
      'BUGATTI',
      'Range Rover',
      'Lexus ',
      'Mini Cooper',
    ],
    paymentFormFooter: (
      <>
        By Proceeding, I understand and agree with the{' '}
        <RouterLink
          style={{
            color: '#003cc5',
            padding: '5px',
            borderRadius: '6px',
          }}
          target="_blank"
          to={'/in/inspection-terms-and-conditions'}
        >
          <strong>Terms of service</strong> and <strong>Privacy Policy</strong>
        </RouterLink>
        of Wisedrive Technologies Pvt Ltd
      </>
    ),
  },
  flexiPay: {
    header: (
      <h2>
        Customise your Car Warranty with our
        <br /> <span style={{ color: '#ff7858' }}>‘Flexi-Pay’</span> solution ..
      </h2>
    ),
    cardContent: [
      {
        color: '#003cc5',
        content: (
          <>
            <div className="flexi-quarterly">
              <div className="flexi-card-header">
                <h6 style={{ color: 'black' }}>
                  Quarterly <br />
                  Payment Plan
                </h6>
                <div className="flexi-card-headright">
                  <p>Starts from</p>

                  <span style={{ fontFamily: 'matter' }}>
                    INR
                    <p
                      style={{
                        fontSize: '22px',
                        fontFamily: 'matterSemibold',
                      }}
                    >
                      1499
                    </p>
                  </span>
                </div>
              </div>
              <div className="flexi-card-body">
                <div style={{ textAlign: 'center' }}>
                  <p className="card-duration-p">
                    0-3 <br /> Months
                  </p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-label-p">Customer</p>
                  <p className="card-percent-p">20%</p>
                  <p className="card-label-p">Co-Pay</p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-label-p">Wisedrive</p>
                  <p className="card-percent-p">80%</p>
                  <p className="card-label-p">Payout</p>
                </div>
              </div>
              <Divider className="divider-css" />
              <div className="flexi-card-body">
                <div style={{ textAlign: 'center' }}>
                  <p className="card-duration-p">
                    4-6 <br /> Months
                  </p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-percent-p">20%</p>
                  <p className="card-label-p">Co-Pay</p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-percent-p">80%</p>
                  <p className="card-label-p">Payout</p>
                </div>
              </div>
              <Divider className="divider-css" />
              <div className="flexi-card-body">
                <div style={{ textAlign: 'center' }}>
                  <p className="card-duration-p">
                    7-9 <br /> Months
                  </p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-percent-p">20%</p>
                  <p className="card-label-p">Co-Pay</p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-percent-p">80%</p>
                  <p className="card-label-p">Payout</p>
                </div>
              </div>
              <Divider className="divider-css" />
              <div className="flexi-card-body">
                <div style={{ textAlign: 'center' }}>
                  <p className="card-duration-p">
                    10-12 <br /> Months
                  </p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-percent-p">20%</p>
                  <p className="card-label-p">Co-Pay</p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-percent-p">80%</p>
                  <p className="card-label-p">Payout</p>
                </div>
              </div>
              <Divider className="divider-css" />
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <a aria-label="" href="/in#contact-us">
                  <Button
                    variant="contained"
                    sx={{
                      color: 'white',
                      fontSize: '18px',
                      fontFamily: 'matterMedium',
                      margin: '10px',
                      backgroundColor: '#e61f93',
                    }}
                  >
                    Contact Sales
                  </Button>
                </a>
              </div>
            </div>
          </>
        ),
      },
      {
        content: (
          <>
            <div>
              <div className="flexi-halfCard-wrap">
                <div className="flexi-halfyearly">
                  <div className="flexi-card-header">
                    <h6 style={{ color: 'black' }}>
                      6 Months <br />
                      Payment Plan
                    </h6>
                    <div className="flexi-card-headright">
                      <p>Starts from</p>

                      <span style={{ fontFamily: 'matter' }}>
                        INR
                        <p
                          style={{
                            fontSize: '22px',
                            fontFamily: 'matterSemibold',
                          }}
                        >
                          2999
                        </p>
                      </span>
                    </div>
                  </div>
                  <div className="flexi-card-body">
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-duration-p">
                        0-6 <br /> Months
                      </p>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-label-p">Customer</p>
                      <p className="card-percent-p">10%</p>
                      <p className="card-label-p">Co-Pay</p>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-label-p">Wisedrive</p>
                      <p className="card-percent-p">90%</p>
                      <p className="card-label-p">Payout</p>
                    </div>
                  </div>
                  <Divider className="divider-css" />
                  <div className="flexi-card-body">
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-duration-p">
                        7-12 <br /> Months
                      </p>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-percent-p">10%</p>
                      <p className="card-label-p">Co-Pay</p>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-percent-p">90%</p>
                      <p className="card-label-p">Payout</p>
                    </div>
                  </div>
                  <Divider className="divider-css" />
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <a aria-label="" href="/in#contact-us">
                      <Button
                        variant="contained"
                        sx={{
                          color: 'white',
                          fontSize: '18px',
                          fontFamily: 'matterMedium',
                          margin: '10px',
                          backgroundColor: '#950000',
                        }}
                      >
                        Contact Sales
                      </Button>
                    </a>
                  </div>
                </div>
                <div className="flexi-yearly">
                  <div className="flexi-card-header">
                    <h6 style={{ color: 'black' }}>
                      One Year <br />
                      Payment Plan
                    </h6>
                    <div className="flexi-card-headright">
                      <p>Starts from</p>
                      <span style={{ fontFamily: 'matter' }}>
                        INR
                        <p
                          style={{
                            fontSize: '22px',
                            fontFamily: 'matterSemibold',
                          }}
                        >
                          4999
                        </p>
                      </span>
                    </div>
                  </div>
                  <div className="flexi-card-body">
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-duration-p">
                        0-12 <br /> Months
                      </p>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-label-p">Customer</p>
                      <p className="card-percent-p">10%</p>
                      <p className="card-label-p">Co-Pay</p>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <p className="card-label-p">Wisedrive</p>
                      <p className="card-percent-p">90%</p>
                      <p className="card-label-p">Payout</p>
                    </div>
                  </div>
                  <Divider className="divider-css" />
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <a aria-label="" href="/in#contact-us">
                      <Button
                        variant="contained"
                        sx={{
                          color: 'white',
                          fontSize: '18px',
                          fontFamily: 'matterMedium',
                          margin: '10px',
                          backgroundColor: '#202020',
                        }}
                      >
                        Contact Sales
                      </Button>
                    </a>
                  </div>
                </div>
              </div>
              <div className="flexi-note">
                <p>
                  * Co-Pay is the percentage of amount to be paid by customer
                  for warranty parts during the said payment period. Please read
                  the warranty conditions at https://wisedrive.co.in
                </p>
                <p>
                  ** Towing and handling charges are to be paid separately
                  billed based on the distance the car is towed.
                </p>
              </div>
            </div>
          </>
        ),
      },
    ],
  },
  comparePage: {
    header: 'Wisedrive Outperforms Normal Used Car Inspections',
    subTitle:
      ' Experience unparalleled peace of mind with WiseDrive’s comprehensive inspections, detailed reports, and unmatched customer assurance for used car buyers.',
    wiseDrivePoints: {
      header: 'Wisedrive Way',
      content: [
        {
          point: (
            <p>
              Inspects engine, transmission, electrical, and mechanical aspects
              thoroughly,{' '}
              <span className="highlet">
                ensuring all critical part is in top condition
              </span>
            </p>
          ),
        },
        {
          point: (
            <p>
              Provides detailed inspection reports with{' '}
              <span className="highlet">
                high-quality photos and diagnostics,
              </span>
              giving clear insights into the car’s condition
            </p>
          ),
        },
        {
          point: (
            <p>
              Utilizes{' '}
              <span className="highlet">OBD-2, ECM, and BCM checks </span>for
              system health, ensuring al electronic systems are functioning
              correctly.
            </p>
          ),
        },
        {
          point: (
            <p>
              Delivers <span className="highlet">personalized advice</span> and{' '}
              <span className="highlet">accurate repair estimates</span> based
              on the inspection results,{' '}
              <span className="highlet">
                helping you understand potential costs
              </span>
            </p>
          ),
        },
        {
          point: (
            <p>
              Offers a <span className="highlet">6-month warranty</span> and{' '}
              <span className="highlet">buyback assurance</span>, giving you
              peace of mind and financial security.
            </p>
          ),
        },
        {
          point: (
            <p>
              Verifies{' '}
              <span className="highlet">
                finance validity, insurance status, traffic challans
              </span>
              and <span className="highlet">vehicle crime records</span>,
              ensuring no hidden financial or legal issues.
            </p>
          ),
        },
      ],
    },
    comparePoints: {
      header: 'Normal Inspections',
      content: [
        {
          point: (
            <p>
              Offers a generaly comprehensive inspection, though{' '}
              <span className="highlet">it lacks depth in some areas.</span>
            </p>
          ),
        },
        {
          point: (
            <p>
              Provides reports with diagnostics but{' '}
              <span className="highlet">
                might not consistently include visual evidence.
              </span>
            </p>
          ),
        },
        {
          point: (
            <p>
              Uses diagnostic tools, though the{' '}
              <span className="highlet">
                checks might not be as thorough and consistent.
              </span>
            </p>
          ),
        },
        {
          point: (
            <p>
              Gives advice and estimates, which might{' '}
              <span className="highlet">
                {' '}
                not always be tailored to customer needs
              </span>{' '}
              but inclines towards financial benefit for garages after purchase.
            </p>
          ),
        },
        {
          point: (
            <p>
              Do not provide warranty or take accountability, typicaly{' '}
              <span className="highlet"> shorter and less comprehensive.</span>
            </p>
          ),
        },
        {
          point: (
            <p>
              Verifies finance and insurance, and offers some additional checks
              and services, though{' '}
              <span className="highlet">these may not be as detailed</span>
            </p>
          ),
        },
      ],
    },
  },
  onlyWhatsApp: {
    header: (
      <>
        <h2 className="whatsapp-mobile-header">
          Unbiased, <br />
          Tech-Driven, <br />
          Customer-Focused, State-of-the-Art Inspections
        </h2>
        <h2 className="whatsapp-header">
          Unbiased, Tech-Driven, Customer-Focused, State-of-the-Art Inspections
        </h2>
        <p>
          At WiseDrive, you experience unparaleled quality with impartial
          inspections, advanced technology, customer-first focus, and
          cutting-edge methods while conducting used car inspections.
        </p>
      </>
    ),
    gradeCardsData: [
      {
        src: UnbiasedCustomer,
        header: 'Unbiased & Customer focused Inspection',
        content:
          'Our inspections are completely transparent and unbiased, providing an objective assessment focused solely on ensuring the highest vehicle quality and reliability.',
      },
      {
        src: AiDrivenLogo,
        header: 'AI Driven - Engine Sound Analysis',
        content:
          'Wisedrive uses advanced AI for analysing the Engine Sound analysis with comparing mi lions of data points for similar cars across the country, ',
      },
      {
        src: OBDScanner,
        header: 'Advanced OBD-2 Scanner Analysis',
        content:
          'Engine Control Module (ECM), Body Control Module (BCM), Transmission Control Module (TCM) analysis of your car with latest OBD-2 scanners.',
      },
      // {
      //   src: BatteryIcon,
      //   header: "Best in the Industry Inspection",
      //   content:
      //     "Wisedrive delivers the best in the industry inspection services. Our team of certified professionals conducts meticulous checks on all aspects of a vehicle, from mechanical and electrical systems to the exterior and interior condition.",
      // },
      // {
      //   src: TurboWarrantyIcon,
      //   header: "Renew Insurance",
      //   content: "Comprehensive coverage of turbo parts are included ",
      // },
      // {
      //   src: AcCompressorIcon,
      //   header: "Insurance Claim support",
      //   content: "Comprehensive AC components warranty ",
      // },
      // {
      //   src: InsuranceClaimSuportIcon,
      //   header: "Subscription details",
      //   content: "Call us for any insurance claim support ",
      // },
      // {
      //   src: InsuranceClaimSuportIcon,
      //   header: "Subscription details",
      //   content: "Call us for any insurance claim support ",
      // },
    ],
  },
  brandGrade: {
    header: (
      <>
        <h2>Showroom-Grade Warranty for your Car</h2>
        <p className="grade-description">
          Wisedrive partners with Authorised service centres of all car brands
          sold in India and provides extensive coverage of warranty across the
          country with it 98% claim approval rate within 24 hours of claim
          request. We provide roadside assistance and pan India service and
          warranty support to our warranty customers.
        </p>
      </>
    ),
    card1: {
      header: 'Electrical Parts',
      content:
        'Electrical Wiring Warranty, Battery Warranty, Infotainment Warranty, Lights and bulbs warranty.',
    },

    card2: {
      header: 'Mechanical parts',
      content: 'Suspension., Shock absorbers, lower arms.',
    },
    card3: {
      header: (
        <h6 style={{ color: 'white' }}>
          Engine & <br />
          Transmission Parts
        </h6>
      ),
      content:
        'Al parts of Engine and Transmission are covered under Wisedrive Comprehensive Warranty program. Automatic transmission is also covered under this program.',
      content1: 'We back our Inspection with FREE Warranty for your car.',
    },
    card4: {
      header: 'Roadside Assistance',
      content: 'RSA is included in Comprehensive Warranty program.',
    },
    card5: {
      header: 'AC Warranty',
      content: 'AC Compressor, AC Cooler, Wiring, AC conductor Wiring.',
    },
  },
  queryPage: {
    header: (
      <div>
        <p className="query-sub-header">How it works ?</p>
        <h2 style={{ color: 'black' }}>
          Buying pre-owned car has never been this{' '}
          <span style={{ color: '#003cc4' }}>Confident</span>!
        </h2>
        <p style={{ color: 'black' }}>
          Send “HI” on whatsapp to 73380 73380 to buy inspection plan, book
          inspection,
          <br /> schedule inspection, reschedule inspection or to talk to
          experts about your car.
          <strong> We are just a “Hi” away to assist you.</strong>
        </p>
      </div>
    ),
    cardsData: [
      {
        img: one,
        headder: 'Buy Inspection Plan',
        body: (
          <>
            <p>Choose the best inspection package for your car.</p>
            <p>
              Buy inspection before you buy the car and assure peace of mind
              post purchase.
            </p>
          </>
        ),
      },
      {
        img: two,
        headder: 'Schedule Inspection',
        body: (
          <>
            <p>
              Schedule inspection online / Whatsapp or call us on +91 73380
              73380 anytime.
            </p>
            <p>You can schedule inspection anywhere in the city hassle free.</p>
          </>
        ),
      },
      {
        img: three,
        headder: 'Get Report in 2 Hrs',
        body: (
          <>
            <p>
              Get your car inspection report in 2 hrs after the completion of
              inspection.
            </p>
            <p>
              We will share the report via a link on whatsapp which you can
              click to view the report.
            </p>
          </>
        ),
      },
    ],
    advisory: (
      <>
        <p>
          Our experts will advise you on all issues of the car and will provide
          assistance in choosing the right car.
        </p>
        <p
          style={{
            color: '#003cc4',
            paddingTop: '0px',
            fontFamily: 'matterMedium',
          }}
        >
          Buying car after Wisedrive Inspection assures Peace of Mind.
        </p>
      </>
    ),
  },
  pricePage: {
    header: (
      <>
        We offer quality,{' '}
        <span style={{ fontFamily: 'matterThin' }}>
          with the best technology and
          <br />
          automotive experts in car inspection
        </span>
      </>
    ),
    subTitle:
      'Trusted by 200,000+ customers for inspecting pre-owned cars before purchase',
    numberCardData: [
      {
        image: inspected,
        number: '200,000+',
        text: 'Customer across the India have trust us before buying used car',
      },
      {
        image: warranty,
        number: '75,000+',

        text: 'Customer buy our warranty post purchase for hassle free ownership',
      },
      {
        image: kilometer,
        number: '80,00,000+',
        text: ' Kilometeres trave led by customers with Wisedrive warranty ',
      },
      {
        image: cities,
        number: '10+ Cities',
        text: 'With 10+ cities coverage we have 7000+ pincodes covered in India',
      },
      {
        image: customerSupport,
        number: 'Customer Support',
        text: 'Our customer support is available 24/7 for Warranty related queries',
      },
      {
        image: roadsideAssist,
        number: 'Roadside Assistance',
        text: 'Got stuck somewhere, cal our helpline to get roadside assistance in 30min',
      },
    ],
  },
  contactUsPage: {
    header: 'Contact us',
    subTitle:
      'Whatsapp, call or complete the form to learn how Wisedrive can protect your investment on buying pre-owned car',
    email: 'support.in@wisedrive.com',
    mobile1: '+91 73380 73380',
    mobile2: '+91 7353 34 35 36',
    dec1header: 'Customer Support',
    dec1Content: (
      <>
        <p style={{ paddingTop: '0px' }}>Wisedriv Technologies Pvt Ltd</p>
        <p style={{ paddingTop: '0px' }}>WeWork, Roshini Tech Hub,</p>
        <p style={{ paddingTop: '0px' }}>Marathahalli Mn Road,</p>
        <p style={{ paddingTop: '0px' }}> Bangalore, Karnataka</p>
        <p style={{ paddingTop: '0px' }}> India - 560037</p>
      </>
    ),
    dec2Header: 'Feedback and Suggestions',
    dec2Content:
      'We value your feedback and are continuously working to improve Wisedrive. Your input is crucial in shaping the future of Used Car inspection in India.',
    formHeader: 'Get in touch',
    phoneCode: 91,
    formSubtitle: 'You can reach us anytime',
    fromLableName: 'Your Name',
    fromLableEmail: 'Your Email',
    fromLablePhone: 'Phone Number',
    fromLableHelpText: 'How can we help?',
    formBtnText: 'Send Message',
    formTerms: (
      <>
        By contacting us, you agree to our
        <span style={{ fontFamily: 'matterBold' }}>
          {' '}
          Terms and Conditions{' '}
        </span>{' '}
        and <span style={{ fontFamily: 'matterBold' }}>Privacy Policy</span>
      </>
    ),
  },
  reviewPage: {
    header: 'Customer Experiences and Reviews',
    subTitle:
      'See How Our Expertise Ensures Confidence in Every Pre-Owned Vehicle Purchase',
    reviewsData: [
      {
        reviewer_name: 'Mallikarjun',
        car: 'Hyundai i10',
        description:
          'Wisedrive’s inspection service was a game-changer for me! I was looking at a used car that seemed perfect, but their thorough inspection revealed some hidden issues. I ended up negotiating a better price thanks to their detailed report. Highly recommend it!',
      },
      {
        reviewer_name: 'Nikita Sharma',
        car: 'Toyota Glanza',
        description:
          'As a first-time car buyer, I was nervous about buying used. Wisedrive made the process so much easier. Their inspector was punctual, professional, and explained everything in simple terms. The report was comprehensive, and I felt confident in my purchase.',
      },
      {
        reviewer_name: 'Dilip Patel',
        car: 'Maruti Swift',
        description:
          'Wisedrive saved me from buying a bad car! The car looked great on the outside, but the inspector found several mechanical issues. Their service is worth every penny if you want to save yourself from fraud when buying a used car.',
      },
      {
        reviewer_name: 'Dharmesh Soni',
        car: 'MG Hector',
        description:
          'I’ve used Wisedrive twice now, and both times they’ve delivered exceptional service. The inspectors are knowledgeable and don’t rush through the process. The detailed reports helped me make informed decisions. Definitely a must-use service for used car buyers.',
      },
      {
        reviewer_name: 'Swati Gorakh',
        car: 'Skoda Octavia',
        description:
          'Impressed with Wisedrive! The inspector was very thorough and caught a few minor issues that I wouldn’t have noticed. The seller even admitted that there were things but small so they hadn’t disclosed. I felt much more confident in my purchase after using this service.',
      },
      {
        reviewer_name: 'Rudra Gowda',
        car: 'Hyundai Venue',
        description:
          'Wisedrive is a must-have service if you’re buying a used car. Their inspection report was detailed and easy to understand. The inspector went above and beyond to check every detail. I’m so glad I used them before making my purchase.',
      },
      {
        reviewer_name: 'Chetana',
        car: 'Volkswagen Polo',
        description:
          'I was on the fence about getting an inspection, but I’m so glad I did! Wisedrive found issues with the transmission that could have cost me thousands. Their service is top-notch and definitely worth the investment.',
      },
      {
        reviewer_name: 'Gomti',
        car: 'Toyota Fortuner',
        description:
          'I’ve always been skeptical of buying used cars, but Wisedrive made the process stress-free. Their inspection was incredibly thorough, and the report gave me confidence that I was making a good purchase. Highly recommend to anyone buying a used car!',
      },
      {
        reviewer_name: 'Naduvinahalli Kariyappa',
        car: 'Ford Endeavour',
        description:
          'The inspector from Wisedrive was friendly, professional, and very detailed. The report covered everything I needed to know, and the customer service was excellent. I felt reassured knowing I had all the information before buying.',
      },
      {
        reviewer_name: 'Rajat Chaudhry',
        car: 'Mahindra Scorpio',
        description:
          'Wisedrive’s inspection service is fantastic! They provided a detailed report that helped me negotiate a better price. The inspector was knowledgeable and answered all my questions. I’ll definitely use them again for future car purchases.',
      },
    ],
    buttonText: '1500+ reviews on Google',
  },
  faqPage: {
    header: 'Frequently Asked Questions',
    subtitle:
      "Everything you need to know about product ad billing. Can't find the answer you're looking for? Contact Us",
    faqData: [
      {
        question:
          'What services does Wisedrive offer for used car inspections?',
        answer:
          'Wisedrive offers comprehensive used car inspections covering critical components such as the engine, transmission, brakes, and electrical systems.',
      },
      {
        question: 'How can i book appointment for car inspections?',
        answer:
          'You can book an inspection through our website or mobile app by selecting your preferred package and scheduling an appointment.',
      },
      {
        question: 'What is included in a Wisedrive used car inspection? ',
        answer:
          'Our inspections cover over 200 checkpoints, including mechanical, electrical, and safety systems.',
      },
      {
        question: 'How does the inspection process work?',
        answer:
          'A certified technician will inspect your car at your location or a partner garage, providing a detailed report afterward.',
      },
      {
        question: 'How long does a typical car inspection take?',
        answer:
          'An inspection usually takes about 1-2 hours, depending on the vehicle’s condition and the package chosen.',
      },
      {
        question: 'Can I request an inspection for any type of vehicle? ',
        answer:
          'We inspect most types of vehicles, including sedans, SUVs, and trucks.',
      },
      {
        question: 'What is the cost of a used car inspection?',
        answer:
          'The cost varies based on the package selected. Detailed pricing is available on our website.',
      },
      {
        question: 'What types of warranties does Wisedrive offer?',
        answer:
          'We offer various warranty plans that cover different aspects of vehicle maintenance and repairs.',
      },
      {
        question: 'How do I purchase a warranty with my inspection?',
        answer:
          'You can add a warranty to your inspection package during the booking process on our website or app.',
      },
      {
        question: 'What does the Wisedrive warranty cover?',
        answer:
          'Coverage varies by plan but generally includes major components such as the engine, transmission, and electrical systems.',
      },
      {
        question: 'Are there any exclusions in the warranty coverage?',
        answer:
          'Yes, some exclusions apply. Please refer to the specific warranty terms and conditions for details.',
      },
      {
        question: 'How do I claim warranty repairs with Wisedrive?',
        answer:
          'Contact our support team to file a claim, and we will guide you through the process and direct you to an authorised service centre.',
      },
      {
        question:
          'Can I transfer my warranty to a new owner if I sell my car? ',
        answer:
          'Yes, warranties can be transferred to new owners, ensuring continued coverage.',
      },
      {
        question: 'What is the validity period of your warranties?',
        answer:
          'Warranty periods vary by package and can range from 6 months to several years.',
      },
    ],
  },
  footerPage: {
    subTitle:
      'Wisedrive is India’s first used car inspection and Used car warranty provider with advanced AI in Automotive Warranty Industry. Wisedrive leads the used car inspection industry with presence in 30 cities in India.',
    footerLinkProducts: {
      header: 'Products',
      links: [
        {
          link: '/in#inspection-plans',
          label: 'Car Inspections',
          type: 'anchor',
        },
        {
          link: '/in#inspection-plans',
          label: 'Used Car Warranty',
          type: 'anchor',
        },
        {
          link: '/in',
          label: 'Car Service & Maintenance',
          type: 'link',
        },
        {
          link: '/in',
          label: 'Car Repairs & Maintenance',
          type: 'link',
        },
        {
          link: '/in#inspection-plans',
          label: 'Luxury Car Inspection',
          type: 'anchor',
        },
      ],
    },
    footerLinkCompany: {
      header: 'Company',
      links: [
        {
          link: '/in/about-wisedrive',
          label: 'About us',
          type: 'link',
        },
        {
          link: '/in#how-it-works',
          label: 'How it works ?',
          type: 'anchor',
        },
        {
          link: '/in#contact-us',
          label: 'Contact us',
          type: 'anchor',
        },
        {
          link: '/in',
          label: 'Visit us',
          type: 'link',
        },
      ],
    },
    footerLinkResources: {
      header: 'Resources',
      links: [
        {
          link: '/in',
          label: 'Blog',
          type: 'link',
        },
        {
          link: '/in',
          label: 'Social Media',
          type: 'link',
        },
        {
          link: '/in',
          label: 'Newsletter',
          type: 'link',
        },
        {
          link: '/in#contact-us',
          label: 'Support',
          type: 'anchor',
        },
        {
          link: '/in#contact-us',
          label: 'Help Centre',
          type: 'anchor',
        },
      ],
    },
    footerLinkPolicies: {
      header: 'Policies & Terms',
      links: [
        {
          link: '/in/inspection-terms-and-conditions',
          label: 'Inspection Terms and Conditions',
          type: 'link',
        },
        {
          link: '/in/warrantyPolicy',
          label: 'Warranty Terms and Conditions',
          type: 'link',
        },
        {
          link: '/in/cancellation_refund_policy',
          label: 'Cancelation & Refund Policy',
          type: 'link',
        },
        {
          link: '/in/terms-and-conditions',
          label: 'Terms and Conditions',
          type: 'link',
        },
        {
          link: '/in/privacy',
          label: 'Privacy Policy',
          type: 'link',
        },
      ],
    },
    footerCopyRight:
      '© Wisedrive Technologies Pvt Ltd. All rights reserved 2025',
    footerCopyRightMobile: (
      <>
        © Wisedrive Technologies Pvt Ltd. <br />
        All rights reserved 2025
      </>
    ),
  },
  aboutUsPage: {
    header: 'About Us',
    leftHeader: (
      <>
        Our mission is <br />
        to assure
        <br /> peace of mind <br />
        for used car buyers
      </>
    ),
    rightContent:
      'Wisedrive is India’s first Generative AI company providing innovative used car inspection service and advanced showroom grade Extended warranty services for used cars in India. We have partnered with OEM authorised services to provide best in class services for our warranty customers post purchase guaranteeing Peace of Mind. We provide Independent & Unbiased 3rd party inspection with Best AI in Automotive Industry and guaranteed Transparent and Accurate used car inspection.',
    cardContent: [
      {
        header: '200,000+',
        description: 'Used Car inspection',
        subTitle: 'Customer who bought our inspections',
      },
      {
        header: '75,000+',
        description: 'Used Car Warranty',
        subTitle: 'Active Warranty Customers in India',
      },
      {
        header: '80,00,000+',
        description: 'Trust in Wisedrive',
        subTitle: 'Km travelled by our happy customers',
      },
      {
        header: '20 Cities',
        description: '7000+ Pincodes',
        subTitle: 'We cater inspection in 20 Cities in India',
      },
    ],
    headerDesc: 'Our Mission',
    header2: 'How we assure peace of mind?',
    subTitle: 'We start by inspecting your car before you purchase',
    missionLeftContent:
      'WiseDrive is committed to protecting used car buyers from the risk of purchasing unreliable vehicles. Our process starts with a thorough inspection of each car, ensuring it meets our stringent quality standards. Only the vehicles that pass our inspection receive the WiseDrive seal of approval. As part of our commitment to customer satisfaction, every approved car comes with a free 60-day warranty. This initial coverage ensures buyers have peace of mind and confidence in their purchase.',
    missionLeftHeader: 'Here’s how it works:',
    missionLeftPoints: [
      'Comprehensive Inspection: Every car is rigorously inspected to identify and address potential issues.',
      'Free 60-Day Warranty: Approved vehicles come with this complimentary coverage, giving buyers immediate protection against unexpected repairs.',
      'Extended Warranty Options: After the initial 60 days, customers have the option to extend their warranty and continue enjoying protection.',
    ],
    missionRightContent:
      'Beyond offering protection during purchase, WiseDrive’s service and maintenance module ensures long-term vehicle health. Through our platform, customers can easily track their vehicle’s maintenance history, receive reminders for upcoming services, and even book appointments with trusted service providers.',
    missionRightHeader: 'Our maintenance features include:',
    missionRightPoints: [
      'Service Reminders: Never miss essential maintenance tasks like oil changes, tire rotations, or brake checks.',
      'Easy Booking: Schedule maintenance appointments directly through the platform with vetted service centers.',
      ' Maintenance History Tracking: Keep all records in one place for better organization and resale value.',
    ],
    missionRightFooter:
      'By combining thorough inspections, warranty protection, and ongoing maintenance support, WiseDrive not only helps buyers avoid bad cars but also ensures their vehicles remain in top condition, enhancing safety and reliability over time.',
  },
  inspectionTerms: {
    header: 'Inspection Terms & Condition',
    contentArray: [
      {
        data: (
          <>
            <strong>Our/We and Us </strong>
            means Wisedrive Technologies PVT LTD Limited
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Agreement </strong>means the agreement between Wisedrive and
            the Customer pursuant to which Wisedrive agrees to procure that an
            Inspector carries out an Inspection in accordance with these terms
            and conditions.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Cancellation Fee </strong>means the amount payable by the
            Customer as referred in these terms and conditions.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Customer/You </strong>mean a customer of Wisedrive who
            places an order for an Inspection.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Fee </strong>means the amount payable by the Customer to
            Wisedrive for the Inspection as set out at{' '}
            <a aria-label="" href="https://www.wisedrive.com">
              https://www.wisedrive.com
            </a>
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Inspection </strong>means an audio visual external vehicle
            inspection and test drive carried out by an Inspector on behalf of
            the Wisedrive for the Customer in accordance with these terms and
            conditions.
          </>
        ),
      },
      {
        data: (
          <>
            Wisedrive provides a number of different categories of Inspection,
            each of which involves different checks. Details of the different
            categories of inspection and the checks that are involved are
            available at{' '}
            <a aria-label="" href="https://www.wisedrive.com">
              https://www.wisedrive.com
            </a>
            &nbsp; or by telephoning 7353 34 35 36. Confirmation of the category
            of Inspection that the Customer has chosen to be carried out on the
            Vehicle.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Inspector </strong>refers to the qualified inspector who
            carries out the Inspection on behalf of Wisedrive. Inspectors are
            subject to availability and may be supplemented by the use of
            appropriate third party agents.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Report </strong>means the written report produced by the
            Inspector as part of the Inspection, which includes the
            Customer&rsquo;s name and address, registration details of the
            specific Vehicle inspected and its location, whether the Vehicle has
            passed or failed the Inspection, a list of checks carried out
            (depending on the type of Inspection which the Customer requires)
            and an outline of any areas of concern which the Inspector has
            decided should be brought to the attention of the Customer.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Report Checklist </strong>means the list of areas which will
            be or have been checked by the Inspector as part of the Physical
            Inspection, which are available at{' '}
            <a aria-label="" href="https://www.wisedrive.com">
              https://www.wisedrive.com
            </a>
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Vehicle </strong>means the vehicle in respect of which the
            Customer requires an Inspector to carry out an Inspection.
          </>
        ),
      },
    ],
    subHeader: 'General',
    listContent: [
      'Inspections are prepared from visual and external checks of the Vehicle only and are limited to the parts and/or items identified on the Report. Inspections do not involve dismantling or disturbing any structure, assembly, component or internal mechanism. The Inspector will carry out a road test of the Vehicle and will produce a Report. There are certain parts of the Vehicle which will not be looked at. You should read the Report Checklist carefully to see what will not be checked.',
      'A copy of the Report will be sent to You by email to the email address You provide when ordering an Inspection. Due to the nature of the internet and the virus-protection software utilised by your internet service provider or loaded on to your computer, it may not be possible in all cases to deliver the Report by email. In the event that You do not receive Your Report within 24 hours of the Wisedrive Vehicle Inspection taking place you must notify Us as soon as reasonably possible in order that We can resend Your Report to You. We shall not be liable to You for any failure to deliver a Report to the extent that non- delivery is outside of Our reasonable control.',
      'Items which are listed on the Report Checklist as a part/item to be checked, but which are not reasonably accessible on the Vehicle, will not be inspected. In such circumstances, We will be under no obligation to inspect and/or report on the part/item in question and the Inspector will mark the relevant section of the Report accordingly.',
      'The vehicle should be reasonably clean to ensure that the Inspector can clearly see and accurately report on the relevant vehicle parts inspected. Where the vehicle is not clean, the Inspector reserves the right not to comment on those parts and will mark the Report Checklist accordingly. In such case, the Report Fee shall be fully payable.',
    ],
    subHeader1: 'Exclusions',
    subTitle: 'The items We do not check are:',
    listExcluded: [
      'Any parts which require dismantling/ removing/ disconnecting or taking apart for inspection purposes',
      'Vehicle data checks',
      'Oil and fuel consumption',
      'Source of oil leaks',
      'Brake lining material (other than what is immediately visible and can be seen without dismantling anything)',
      'Brake fluid for contamination. Brake fluid will deteriorate over a period of time and We advise that it be replaced as recommended by the Vehicle manufacturer',
      'Operation of cassette, compact-disc players, TV/DVD/satellite navigation systems, Bluetooth or other in-car entertainment',
      'Sound or radio reception and alarm systems',
      'Cylinder compression, vehicle electrics and electronics which would require specific diagnostic equipment',
      'Exhaust emissions and/or catalytic converters. If this is assessed by the Inspector as passing the Inspection it only relates to confirming its external condition, gas tightness and security. The Inspector is unable to confirm its internal condition or effectiveness as this requires exhaust emission testing which is not included in the Inspection',
      'The accuracy of in-car computer systems (for example, but in no way restricted to, computers used for route finding, fuel efficiency or otherwise)',
      'Exhaust emissions',
      'Air conditioning functions and efficiency',
      'The habitation area of Motorhomes - The electrical systems and appliances, water fittings and appliances, and the gas fitting and appliances are not checked. These are beyond the scope of the Inspection. It is strongly advised that these are tested and checked by a suitably qualified person prior to purchase',
      'Vehicle Technical Systems - Many vehicles are fitted or equipped with automatic or computerised operating systems, which may be controlled by microprocessors. These include engine-management systems, fuel systems, ignition systems, air- conditioning systems, lambda-controlled systems, stereo radio, cassettes, amplifiers, compact discs (single and multi), TV/DVD, satellite navigation, active and self- levelling suspensions, gearboxes, turbo-chargers and superchargers, anti-lock braking systems, four-wheel drive and electronic lockable differential units, traction control, alarm and immobiliser systems, catalytic exhaust systems, and variable camshaft timing systems.',
      'Within the scope of the Inspection it is not possible to check fully the detailed operation of these systems due to the many variations in features and operating modes, and it is not possible to confirm that these systems are functioning fully to the manufacturers design specifications. As a result, the Inspector is unable to confirm the detailed operation of any of these systems other than giving an overall view and opinion on the performances generally inspected or checked. Therefore, We cannot be held in any way liable to You for failing to identify any malfunction or failure of any of these systems to perform to the specification as designed by the manufacturer',
      'Non-standard accessories as a result of personal modifications or otherwise',
    ],
    subheader2: (
      <p>
        Furthermore, <strong>the Inspection cannot: </strong>
      </p>
    ),
    inspectionCannotListItems: [
      'a) confirm whether or not the passenger or luggage compartments (including the <br /> &nbsp;body or caravan area of any Motorhome) are watertight',
      'b) predict the life expectancy of exhaust systems, clutches or dual-mass flywheels',
      'c) provide any indication of any faults which might have become apparent had the Vehicle been driven in excess of the speed reached or the distance travelled during any road test carried out by the Inspector',
      'd) confirm that all or any of the components of the Vehicle are original components, or replacement components that have been manufactured by the manufacturer of the vehicle',
      'e) include the inspection of any parts, components or areas of the Vehicle that are not reasonably visible or accessible to the Inspector at the time of the Inspection',
      'f) confirm authenticity of the Vehicle’s Registration Document, the mileage, the Excise Licence, the Vehicle Identification Number (VIN), the Engine Number, the Registered Number or the Vehicle service history',
      'g) check for any recall notices. Wisedrive recommends that You check with the RTO or manufacturer that the Vehicle has not been subject to such notices.',
    ],
    listContent1: [
      <>
        <strong>The Inspection can only </strong>describe and/or identify
        defects actually found and/or which are reasonably capable of being
        found upon an external visual examination of the Vehicle at the time of
        Inspection. We cannot be held liable and are not responsible for any
        latent defects which are later discovered unless We can reasonably have
        been expected to see them during an Inspection conducted within the
        parameters of these terms and conditions. We cannot advise of defects if
        We cannot see them, or they are not apparent during the Inspection of
        the Vehicle concerned. In particular, please note that (without limiting
        the foregoing) Vehicles over 5 years old, those that have a high mileage
        and/or have been subjected to abnormal use may have latent defects.
        While such defects may, in appropriate circumstances, give rise to a
        claim against the seller of the Vehicle, they fall outside the scope of
        the Inspection and the Report is provided on this basis. Neither
        Wisedrive nor the Inspector will have any liability to You as a result
        of such defects.
      </>,
      <>
        <strong>Please note </strong>that used vehicles may contain serious
        internal, structural or mechanical defects and/or hidden corrosion,
        which will not be detectable from an external, visual examination. These
        vehicles may prove to be less reliable and may need more frequent
        repairs/servicing than more modern vehicles. While Our Inspectors take
        care to identify potential problems with the Vehicle from their external
        visual examination, You accept these and other disadvantages in owning a
        used vehicle and You accept that neither Wisedrive nor the Inspector
        will have any liability to You as a result of such defects.
      </>,
      'If there is no documentary evidence of a recent engine timing belt (cam belt) replacement, We recommend that the belt of the Vehicle is checked or replaced prior to purchase.',
      'If the Vehicle does not have a recent service history or it was not available to the Inspector at the time of the Inspection, then We recommend that a service in accordance with the Vehicle manufacturer&rsquo;s specifications be undertaken prior to purchase. This may highlight other defects, giving rise to repairs, which were not apparent from the external visual examination undertaken by the Inspector.',
      <>
        <strong>Please note </strong>that the life expectancy of an exhaust or
        clutch system is uncertain and difficult to predict. The fact that such
        items have not been identified as faulty on the Report does not and
        should not be taken to imply that such systems will have a continuing
        life expectancy from the time of Our check.
      </>,
    ],
    subHeader3: (
      <>
        <strong>Road Testing </strong>
      </>
    ),
    listContent2: [
      <>
        In order for our Inspectors to carry out a Road Test on the Vehicle, You
        must ensure that the vehicle contains sufficient:
        <br /> (a) Water; <br /> (b) Oil;
        <br /> (c ) Petrol.
      </>,
      'Road testing is carried out within the immediate area of the Inspection. If:',
      'The Vehicle is an unroadworthy condition or the Vehicle contains insufficient oil, water and/or petrol',
      'The Customer is unable to confirm that the Vehicle has a valid fitness certificate and therefore a road test cannot be carried out at the time of Inspection',
      'The Fee for the Inspection shall remain fully payable and an additional Fee will be payable for any subsequent road test You ask Us to undertake.',
      'The carrying out of a road test does not mean that Our Inspector has seen a valid fitness certificate. Obtaining necessary permissions, access to Vehicle etc',
      'It is the Customer’s responsibility to, and the Customer must, ensure that proper provision is made (including the obtaining of any necessary permission from the owner of the Vehicle) for the Inspection to be carried out on garage premises or on an off-road site with an adequate level, hard, dry standing area. Our Inspector needs enough room to be able to walk round the Vehicle and fully open all doors. There must also be enough room for Our Inspector to park his own vehicle close to the Inspection site.',
      'Good quality indoor lighting or daylight (if the Vehicle is outside) must be provided in the location where the Inspection is carried out. We are unable to check Vehicles in poor light or darkness.',
    ],
    subHeader4: 'Fees and cancellations ',
    listContent3: [
      'The Fee must be paid during the time of booking the Inspection.',
      <>
        We reserve the right to refuse to carry out an Inspection or to issue a
        Report on any vehicle: the Inspector cannot reasonably access; or
        appears to the Inspector to be: <br /> (a) not of standard production
        (for example, but not limited to, kit cars); <br /> (b) modified or not
        in regular use (for example, which show signs of excessive corrosion on
        moving parts associated with being left standing and which may result in
        the Vehicle being unsafe to drive without rectification); <br /> (c)
        un-roadworthy or unsafe to drive
      </>,
      'Any of the circumstances referred to in these T&C',
      'Where the Customer has failed to ensure that the proper provision has been made for the Inspection to be carried out, as required',
      'Where the Customer has provided incorrect or incomplete information that has prevented Us from carrying out an Inspection and You acknowledge that in such circumstances We are entitled to treat the Agreement as terminated and to retain the Fee in full. If You wish Us to carry out a further Inspection, You will be required to pay a further Fee at the time of booking.',
      'You have the right to cancel an Inspection and receive a full refund of the Fee, 24hrs before the inspection is scheduled. Once the inspection is carried out no refund will be issued.',
      'To cancel an Inspection, You must inform Our Service Support Team of your decision to cancel by emailing Support.in@wisedrive.com or by calling 7353 34 35 36, Monday to Friday 9am to 5pm. To enable us to find Your order, you will need to provide Your name, address, telephone number and booking reference (as provided with your booking confirmation) together with Your cancellation request.',
    ],
    subHeader5: 'Complaints',
    listContent4: [
      'If You have a complaint or are dissatisfied with any Inspection carried out, please contact Us on 73533 334 35 36 as soon as possible. We may need to re-inspect the Vehicle to deal with the complaint and You agree to allow Us to do so.',
      'No repairs should be effected or any parts replaced on the Vehicle which is the subject of a complaint before the Vehicle has been re-inspected by Us. Should emergency repairs be required to make the Vehicle safe and which is then later to be the subject of a complaint to Us, then You must ensure that a complaint is made to Us (including notification of the need to carry out emergency repairs) within a reasonable time after discovering the problem, and that any faulty or worn parts which are repaired or replaced are retained for future re-examination by Us. We will not, under any circumstances, be responsible for the cost of any repairs carried out or parts replaced without Our previous agreement in writing.',
      'We reserve the right to require another of Our Inspectors to re-inspect any Vehicle at Our own expense should it be considered necessary by Us to deal with any complaint and You are required to allow Our inspector to do so in accordance with these terms and conditions. We will provide an unbiased second opinion on the initial Report issued.',
    ],
    subHeader6: 'Matters outside of Our reasonable control',
    listContent5: [
      'We will not be liable for delay to/non-performance of the Inspection due to events or circumstances outside Our reasonable control. We will take steps to minimise the effects of this where possible.',
      'Wisedrive will only be liable to the Customer (and not to any other person) to the extent that Wisedrive fails to carry out the Inspection in accordance with these terms and conditions. Without limiting the foregoing, You acknowledge that neither Wisedrive or the Inspector will be liable to You or any other person for any liability, loss, damage, claim, proceedings, costs or expenses (together referred to as “Losses”) suffered or incurred by any circumstances where:',
      'such Losses are not a reasonably foreseeable result of any such breach (Losses are foreseeable where they could be contemplated by You and Us at the time the Vehicle is inspected)',
      'such Losses were not caused directly by a breach by Us or the Inspector of these terms and conditions',
      'such Losses comprise business losses or other losses to customers who are not consumers',
      'such Losses increase as a result of a breach by You of any of these terms and conditions.',
      'Nothing herein will affect the statutory rights of a consumer under any applicable statute.',
    ],
    subHeader7: 'Enforcement of terms',
    listContent6: [
      'Each of the clauses of these terms operates separately. If any court of relevant authority decides that any of them are unlawful, the remaining clauses will remain in full force and effect.',
      'The Agreement is between You and Wisedrive. No other person shall have any rights to enforce any of its terms. Neither of us will need to get the agreement of any person in order to make any changes to these terms.',
    ],
    subHeader8: 'Report advice',
    listContent7: [
      'You are strongly advised to discuss the findings within the Report with the seller prior to making any decision to purchase the Vehicle. If You have not viewed the Vehicle personally, You must ensure that the Vehicle’s cosmetic appearance and specification is satisfactory and suitable for your needs and expectations. We suggest You do so by viewing and driving the Vehicle yourself, prior to making your purchasing decision.',
    ],
  },
  warrantyTerms: {
    header: 'Warranty Exclusions and Terms & Conditions',
    subHeader1: 'Warranty Description',
    point:
      'Service Inclusive and/or Repair Inclusive are performed as mentioned in the plan details. The customer voluntarily opted to purchase Service Inclusive/Repair Inclusive packages, a value-added product offered by WISEDRIVE TECHNOLOGIES PVT LTD exclusively for personal use only. To avail of additional benefits by payment of additional costs are subject to customer discretion. Hence, WISEDRIVE TECHNOLOGIES PVT LTD intends to sell Service Maintenance Plans to the customer through authorised used car dealers and online via www.wisedrive.in in India, subject to the Terms and Conditions mentioned below. The customer hereby confirms that he has fully understood and accepted the same. Service and Repair Inclusive is only applicable to the original factory-built product specifications.',
    subHeader2: 'Duration of Package Coverage (For All Packages):',
    durationList: [
      "The package commences at the vehicle's defined warranty start date as per the package Activation date",
      'Costs for services and repairs that were carried out before the purchase of the packages are not covered or cannot be refunded back',
      'The package terminates when the time limit threshold is reached, which is valid for either 6 months (180 days) or 12 months 365 days), or until the vehicle reaches 10,000 kilometres, (whichever occurs earlier). Based on the package subscribed by the customer.',
      'If the car is approved under the cooling period the condition of the cooling period KMS & Days mentioned has to be completed before a warranty claim can be made.',
    ],
    subHead3: 'Exclusions',
    subtitleExclusions:
      '(The following services are not included in the "Repair Inclusive")',
    exclusionsList: [
      'Fuel and contamination in the fuel system and consequential damage Damage to paint finish, body, covers, and panels.',
      'All kinds of glass defects and/or accidental damages (e.g. mirrors, windows, headlight housing, optical distortion, spots, blurriness, etc).',
      'Tyres, wheel balance weights, and wheel damage.',
      'Repairs for which the vehicle user is responsible (engine damage due to deficiency of oil, overdue oil change, and participation in racing events).',
      'Hydrostatic lock, flood and/or accidental damages.',
      'Hydrostatic lock, flood and/or accidental damages.',
      'Bulb, etc. (except LED and Xenon Lights).',
      'Odours and dust accumulation-related defects like wiper washing system nozzles, etc.',
      'Repair or results caused by the usage of original/non-original accessories.',
      'Accidental and general damages caused by external forces, collision, flood, corrosion, f fire, theft, rat bite, or any consequential damages that occurred due to external factors and are not related to any manufacturing defect are not covered under the Wisedrive prepaid maintenance plan.',
      'All adjustments like Wheel Alignment, Balancing, Headlight alignment, etc are not covered under the Wisedrive prepaid maintenance plan.',
      'Body and Paint surface-related concerns are not covered under the Wisedrive prepaid maintenance plan. Schedule Maintenance-related parts like lubricants, filters, brake fluids, steering fluids, drive Belts, spark plugs, Coolant, wiper, etc as applicable.',
      'All consumables like Brake Cleaners, Grease, Ac gas, additives, Fuse, and Relay. Complete Exhaust systems like Silencer pipe, Muffler, Catalytic Converter, and Diesel Particulate Filter.',
      'All batteries like Starter batteries, Auxiliary batteries, and Remote key batteries.',
      'All light assemblies including Headlights, Tail lights, and fog lamps.',
      'All wear and tear parts like wheels, Brake pads and Discs, Clutch plate, Suspension related rubber parts like, bushes, Shock absorbers, Boot shock absorbers, Air suspension struts, Air Bellows, Sunroof rail Sunroof Guide, pulleys, Plastic and Rubber parts.',
      'All rubber mountings like Engine mountings, Transmission mountings, and exhaust pipe mounting.',
      'Charges towards Diagnosing, Checking/testing, Software updates, and Adaptation.',
      'All accessories and external fitted parts like entertainment system, and add-on kits.',
      'Multimedia remote, centre locking remote, Dashboard, centre console, Armrest, clock, Roof lining, sunroof curtain, Floor carpets, Sound and heat insulations.',
      'All consequential damages are caused due to factors like water seepage/ingress to electric and non-electric components.',
      'All failures reported due to delays or lapses in carrying out scheduled maintenance/repairs at authorised dealerships.',
      'All consequential damages or failure due to fitment/usage of non-genuine spare parts, lubricants, or accessories.',
      'All consequential failures were reported due to the usage of adulterated or wrong fuel.',
      'All Pre-existing defects observed/captured during evaluation or reported before the issue of the policy until it is rectified by an Authorised dealership.',
      'All claims reported on a vehicle that was declared cash loss/total loss by insurance or any competent authority and then repair.',
      'All failures and consequential failures reported due to continuous usage of the vehicle in spite of getting fault codes or failure to identify the problem in the vehicle.',
      'Wisedrive Warranty Package does not include any reimbursements for any external repairs/replacements done by you or for any other accidental damages.',
    ],
    subHead4: 'This warranty shall not apply to:',
    warrantNotApplyList: [
      'Normal maintenance services including without limitation, cleaning & polishing, injector cleaning, engine decarburizing, engine tuning, oil/fluid changes, filters replenishment, fastener retightening, adjustments of doors, brake and clutch, wheel balancing, wheel alignment, Tire rotation, headlamp alignment.',
      'Replacement of parts as a result of normal wear and tear, such as spark plugs, belts, brake pads, brake shoes, brake discs, clutch disc/pressure plate, filters, wiper blades, bulbs, fuses, brushes, hoses, Tire/tube, battery, audio system, audio video navigation (AVN), catalytic converter, silencer/exhaust pipe.',
      'Tie Rod ends, Steering Ball Joints, Rear Shocks, Front Struts, Tail Door lifters, and Front & Rear Wheel Bearings/wheel hubs are not covered beyond 60,000 Km of operation.',
      "Rubber parts like Wheel Cylinder kit, all doors weather-strips/beadings & A/C 'O' rings, Clutch cable, Accelerator cable, Speedometer cable & Tail Door Opener cable.",
      'Leakage of A/C refrigerant.',
      'Normal ageing, deterioration, or rusting of plated parts, paint coat, rubber parts, upholstery, soft trim, etc.',
      'Body, paint, glass, interior/exterior trim, exhaust systems, and normal wear and tear of any other component.',
      'Wisedrive policy has a default cooling period of 10 days; any claim registered within this period will not be covered or approved.',
      'If the Vehicle model is equipped with an LPG Kit/ CNG Kit (Either Manufacturer fitted or Locally fitted) is not applicable for Wisedrive Extended Warranty.',
    ],
    subtitle5: 'Damage or failure resulting from:',
    DamageFailureList: [
      'Warranties will become void and will not be reinstated if the car is ‘not’ serviced in a timely manner by the customer who is: 1st General Service*- Done within 3 months or up to 3,000 Kms from the date of Warranty package activation (whichever occurs first).',
      'Misuse, abuse (such as racing, overloading, riding over the clutch), accident or collision, theft, flooding, or fire.',
      'Use of improper, adulterated, or insufficient fuel, fluids, or lubricants.',
      'Use of parts other than OEM Genuine Parts.',
      'Any device and/or accessories not supplied or not approved by Wisedrive.',
      'Modifications, alterations, tampering, or improper repair.',
      'Parts used in applications for which they were not designed or not approved by Wisedrive.',
      'Any repair carried out other than by Wisedrive Authorised Dealer / Service Centre.',
      'Slight irregularities not recognized as affecting the quality or function of the vehicle or parts, such as slight noise or vibrations, or items considered characteristic of the vehicle.',
      'Airborne fallout, Industrial fallout, acid rain, flood, hail, wind storms, or other Acts of God.',
      'Paint scratches, dents, or similar paint or body damage.',
      'Revolution or Mutiny, any intentional or mollified act of the owner or a driver, abuse of the vehicle, negligence.',
      'The action of road elements (sand, gravel, dust, or road debris) results in stone chipping of paint/glass or damage to any other part.',
      'The vehicle which has been used for any sort of competition, sport, rally, transport for hire of persons or goods, Taxi service or short or long-term self-drive hire or driving school, or any commercial use.',
      'Any vehicle purchased as a taxi under the special excise concessions or registered as a Tourist taxi with the Transport Authorities.',
      'The vehicle in which the odometer has been tampered with, changed, or disconnected.',
      'Incidental or consequential damages, including without limitation, loss of time, inconvenience, loss of use of vehicle, or commercial loss.',
      'No liability will be accepted for any losses covered under an accidental damage or road risk policy or for any road hazard/fire or accident damage, no liability of any kind exists in respect of a third party.',
      'No liability will be accepted for damage caused by neglect, intrusion of foreign or harmful or injurious matter, lack of servicing, overheating, freezing, or abuse to the continued use of the vehicle after a fault has become evident or for consequential loss on the failure of parts not is covered by this Extended Warranty.',
    ],
    subHead6: 'OTHER TERMS:',
    otherTermsList: [
      'Service Inclusive and/or Repair Inclusive packages are available for all used cars* across all model ranges (Except Luxury Vehicles) on sale in India.',
      'The customer needs to order Service and/or Repair Inclusive through the Wisedrive Mobile app in my plans section or through customer support at +91 7353343536.',
      'All servicing and maintenance jobs must be carried out at a Wisedrive Authorised Service Workshop or by Wisedrive Approved Technicians.',
      'Service Inclusive and/or Repair Inclusive is transferable to subsequent owners after re-inspection approval but not transferable to another car at a fee.',
      'The customer can request for cancellation of the Service Inclusive and/or Repair Inclusive Package within two weeks from the date of activation of the package provided no services have been availed on the car under any scope. No cancellation or refund will be made after the above-stated period.',
      'In the event the vehicle covered under Service Inclusive and/or Repair Inclusive is involved in an accident rendering it beyond economical repairs/total loss, Wisedrive Service maintenance Plan Services Inclusive and/or Wisedrive Repair Inclusive cover will be annulled and no reimbursement will be made for the remaining period of the validity. No cancellation request can be processed either.',
      'There are no refunds for past service jobs.',
      'WISEDRIVE TECHNOLOGIES PVT LTD reserves the right to discontinue, alter, adjust, add, or remove any packages, the scope of services, exclusions, inclusions, etc. without any prior notice. For the latest Terms and Conditions, policy and prices, etc. please visit www.wisedrive.in',
      'The construction, interpretation, and meaning of the provisions of these Terms and Conditions shall be determined in accordance with Indian law. The Bangalore Court shall have exclusive jurisdiction.',
      'The warranty Holder must confirm with WISEDRIVE TECHNOLOGIES PVT LTD before proceeding with any type of vehicle repair during the Warranty period. In case any repair is conducted without prior approval and confirmation, the Warranty will be invalidated.',
      'No dealer or its agent or employee is authorised to extend or enlarge this warranty and no dealer or its agent or employee is authorised to make any oral warranty on Wisedrive behalf. Warranty service shall be provided only by Wisedrive authorised dealers and Dealer Service Branch. Wisedrive decision is final and binding on the Owner of the vehicle in all warranty matters. Wisedrive reserves the right to the final decision on all warranty matters.',
      'The dealer, agent, or any associated personnel does not possess the authority or rights to facilitate or undertake any repairs on behalf of Wisedrive Warranty. It is explicitly stated that the dealer, agent, or their employees are prohibited from arranging or committing to any repairs for the vehicle covered by the Wisedrive Warranty.',
      'The dealer, agent, or their employees are not authorized to make warranty claims on behalf of the customer. Any attempt to do so would constitute a violation of the terms and conditions of the warranty agreement. This adherence to proper procedures ensures the integrity of the warranty process and upholds the contractual obligations between the customer and Wisedrive Warranty. Any deviation from these guidelines may result in a breach Violation of the warranty agreement and subsequent consequences.',
    ],
    subHeads7:
      'Customer Obligation: Fitness Certificate Requirement for Warranty Claim',
    customerObligationFitnessList: [
      'In order to be eligible for a warranty claim, it is a prerequisite for the customer to possess a valid fitness certificate for the vehicle. This requirement applies specifically to vehicles that are more than 15 years old or as stipulated by the prevailing government regulations. Failure to provide a valid fitness certificate when filing a warranty claim will result in the rejection of the claim.',
      'It is essential to understand that the presentation of a fitness certificate is a mandatory condition for the approval of warranty claims. This requirement is in place to ensure compliance with legal and regulatory standards.',
      'We strongly urge customers to ensure they possess a valid fitness certificate for their vehicle before attempting to raise a warranty claim. Failure to meet this requirement may result in the denial of the claim, as per the terms and conditions set forth by Wisedrive.',
    ],
    subHead8: 'Customer Obligation: New RC Card Update for Wisedrive Warranty',
    customerObligationRcList: [
      'The customer is solely responsible for promptly updating the new Registration Certificate (RC) card of the vehicle with Wisedrive within a period of 45 days from the date of activating the Wisedrive Warranty. Failure to fulfil this obligation within the specified 45-day timeframe will automatically render the Wisedrive Warranty void and without effect.',
      'In the event of voiding the warranty, the customer may request a reinspection of the vehicle by the Wisedrive team to reinstate the warranty package. However, the availability of inspection slots is subject to the discretion and scheduling of the Wisedrive team. During the period between warranty voiding and completion of the reinspection, the warranty shall remain non-claimable and void. The continuation of the car warranty is subject to the discretion of the Wisedrive team, and their findings during the inspection process.',
      'It is important to note that Wisedrive reserves the right to reject the reapproval of the warranty based on the results of the inspection.',
      'We emphasise the significance of complying with this obligation to ensure the uninterrupted validity and coverage of your Wisedrive Warranty.',
      "In order to make a warranty claim, it is imperative that the car owner's name and the details provided in the vehicle's Registration Certificate (RC book) align with the information stated in The warranty policy. Any discrepancy or inconsistency between the owner's details and the warranty documentation may result in the rejection of the warranty claim.",
      'It is the responsibility of the car owner to ensure that the information contained in the RC book, including their name, address, and other relevant particulars, accurately corresponds to the details provided in the warranty policy. Any changes or updates to the information should be promptly communicated to the Wisedrive authorities and duly reflected in both the RC book and warranty documentation.',
      'Wisedrive reserves the right to reject warranty claims if there is a failure to comply with these requirements. It is recommended that car owners meticulously review and verify the accuracy of their information in both the RC book and warranty policy to avoid any potential complications or warranty claim rejections.',
    ],
    subHead9: 'Owner’s Responsibilities:',
    responsibilitiesList: [
      'Proper use, maintenance, and care of the vehicle in accordance with the instructions contained in the Owner’s Manual and Service Booklet. If the vehicle is subject to severe usage conditions, such as operation in extremely dusty, rough, more repeated short-distance driving or heavy city traffic during hot weather, maintenance of the vehicle should be done more frequently as mentioned in the Owner’s Manual and Service Booklet.',
      'In order to maintain the validity of this Extended Warranty, the vehicle must be serviced by Wisedrive Authorised Service Centres/Dealers in accordance with the Owner’s Manual and Service Booklet.',
      "Retention of maintenance service records. It may be necessary for the customer to show that the required maintenance has been performed, as specified in the Owner's Manual and Service Booklet.",
      "Delivery of the vehicle along with the Owner's Manual and Service Booklet and Extended Warranty Certificate during regular service business hours to any authorised Wisedrive Dealer to obtain warranty service.",
    ],
    subHead10: 'Driver/Manual Errors Not Covered Under Warranty Claim',
    subTitle1: 'Failure to maintain proper oil levels:',
    subTitleList: [
      'Neglecting to regularly check and maintain engine oil at recommended levels.',
      'Insufficient lubrication leads to increased friction and wear on engine components.',
      'Potential consequences: Engine failure, damage to internal parts.',
    ],
    subTitle2: 'Ignoring oil change intervals:',
    subTitle2List: [
      'Neglecting timely oil changes causes oil degradation and reduced lubrication.',
      'Contaminated oil leads to increased engine wear and potential failure.',
      'Potential consequences: Engine failure, and decreased engine performance.',
    ],
    subTitle3: 'Overheating the engine:',
    subTitle3List: [
      'Allowing the engine to overheat due to cooling system malfunctions or low coolant levels.',
      'Excessive stress on the engine leads to severe damage.',
      'Potential consequences: Warped cylinder heads, blown head gaskets, seized engine.',
    ],
    subTitle4: 'Using incorrect fuel or oil:',
    subTitle4List: [
      'Using the wrong type of fuel (e.g., gasoline instead of diesel) or improper engine oil.',
      'Interference with engine combustion process and poor performance.',
      'Potential consequences: Engine damage, and decreased fuel efficiency.',
    ],
    subTitle5: 'Ignoring warning signs:',
    subTitle5List: [
      'Disregarding engine warning signs like unusual noises, excessive smoke, loss of power, or dashboard warning lights.',
      'Failure to address early indications of engine problems.',
      'Potential consequences: Further damage, engine failure, compromised safety.',
    ],
    subTitle6: 'Over-revving or redlining the engine:',
    subTitle6List: [
      'Revving the engine excessively or operating it consistently at high RPMs.',
      'Placing excessive stress on engine components and accelerating wear.',
      'Potential consequences: Increased engine wear, and reduced engine lifespan. Improper maintenance and neglect:',
      'Failing to perform routine maintenance tasks (e.g., timing belt replacement, spark plug replacement, air filter replacement).',
      'Deterioration of engine components due to neglect.',
      'Potential consequences: Engine issues, decreased performance, increased risk of failure.',
    ],
    subNote:
      "It's important to note that this list is not exhaustive, and specific vehicle models may have additional guidelines and requirements outlined in their respective owner's manuals. Always refer to the manufacturer's recommendations and follow proper maintenance procedures to ensure the longevity and performance of your vehicle.",
    noteHeader: 'Important Note:',
    noteList: [
      'This Extended Warranty is transferable to subsequent owners for the remaining Warranty Period after re-inspection approval.',
      'Wisedrive has the right to cancel/ decline the warranty transfer request based on reinspection.',
      'This Extended Warranty scheme has no surrender value, no refund of warranty premium is is is available and it cannot be transferred to another vehicle.',
      'Extended Warranty is not applicable on Taxi/Fleet and Test Drive vehicles.',
      'All Maintenance services and warranty claim repairs will be exclusively conducted at the district level within Karnataka state at Wisedrive Authorised/approved Service centre/ Center/Workshop.',
      'Valid vehicle insurance must be presented by the warranty holder at the time of submitting/Requesting a warranty claim. Failure to provide proof of insurance will lead to the rejection of the warranty claim.',
      'Warranty Claim requests for warranty coverage outside of Karnataka state will not be considered feasible or viable.',
      'All Maintenance services for service requests outside of Karnataka state will not be is considered feasible or viable.',
      'Extended Warranty Prices are subject to change without any prior notice.',
      'All above Extended Warranty options are subject to change/obsolete without any prior Notice.',
      'Warranty Holder needs to raise a claim request/query via the helpline channels (Email- Claims.in@wisedrive.com, Mobile no - 7353343536 ) within 48hrs from the occurrence of the claim event, failing to do so would render the claim invalid.',
      'All disputes arising out of this Extended Warranty will be subject to the jurisdiction of Courts in Bangalore only.',
      'Wisedrive reserves the right to make improvements or change the features or the design of all Wisedrive coverage plans at any time with no obligation on the vehicle already assured. For the latest Terms and Conditions, policy and prices, etc. please visit www.wisedrive.in or reach out to Wisedrive customer support on 7353343536 over the phone or email us at support.in@wisedrive.com.',
    ],
  },
  termsPage: {
    header: 'Terms & Conditions',
    contentArray: [
      {
        data: (
          <>
            <strong>Our/We and Us </strong>
            means Wisedrive Technologies PVT LTD Limited
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Agreement </strong>means the agreement between Wisedrive and
            the Customer pursuant to which Wisedrive agrees to procure that an
            Inspector carries out an Inspection in accordance with these terms
            and conditions.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Cancellation Fee </strong>means the amount payable by the
            Customer as referred in these terms and conditions.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Customer/You </strong>mean a customer of Wisedrive who
            places an order for an Inspection.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Fee </strong>means the amount payable by the Customer to
            Wisedrive for the Inspection as set out at{' '}
            <a aria-label="" href="https://www.wisedrive.com">
              https://www.wisedrive.com
            </a>
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Inspection </strong>means an audio visual external vehicle
            inspection and test drive carried out by an Inspector on behalf of
            the Wisedrive for the Customer in accordance with these terms and
            conditions.
          </>
        ),
      },
      {
        data: (
          <>
            Wisedrive provides a number of different categories of Inspection,
            each of which involves different checks. Details of the different
            categories of inspection and the checks that are involved are
            available at{' '}
            <a aria-label="" href="https://www.wisedrive.com">
              https://www.wisedrive.com
            </a>
            &nbsp; or by telephoning 7353 34 35 36. Confirmation of the category
            of Inspection that the Customer has chosen to be carried out on the
            Vehicle.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Inspector </strong>refers to the qualified inspector who
            carries out the Inspection on behalf of Wisedrive. Inspectors are
            subject to availability and may be supplemented by the use of
            appropriate third party agents.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Report </strong>means the written report produced by the
            Inspector as part of the Inspection, which includes the
            Customer&rsquo;s name and address, registration details of the
            specific Vehicle inspected and its location, whether the Vehicle has
            passed or failed the Inspection, a list of checks carried out
            (depending on the type of Inspection which the Customer requires)
            and an outline of any areas of concern which the Inspector has
            decided should be brought to the attention of the Customer.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Report Checklist </strong>means the list of areas which will
            be or have been checked by the Inspector as part of the Physical
            Inspection, which are available at{' '}
            <a aria-label="" href="https://www.wisedrive.com">
              https://www.wisedrive.com
            </a>
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Vehicle </strong>means the vehicle in respect of which the
            Customer requires an Inspector to carry out an Inspection.
          </>
        ),
      },
    ],
    subHeader: 'General',
    listContent: [
      'Inspections are prepared from visual and external checks of the Vehicle only and are limited to the parts and/or items identified on the Report. Inspections do not involve dismantling or disturbing any structure, assembly, component or internal mechanism. The Inspector will carry out a road test of the Vehicle and will produce a Report. There are certain parts of the Vehicle which will not be looked at. You should read the Report Checklist carefully to see what will not be checked.',
      'A copy of the Report will be sent to You by email to the email address You provide when ordering an Inspection. Due to the nature of the internet and the virus-protection software utilised by your internet service provider or loaded on to your computer, it may not be possible in all cases to deliver the Report by email. In the event that You do not receive Your Report within 24 hours of the Wisedrive Vehicle Inspection taking place you must notify Us as soon as reasonably possible in order that We can resend Your Report to You. We shall not be liable to You for any failure to deliver a Report to the extent that non- delivery is outside of Our reasonable control.',
      'Items which are listed on the Report Checklist as a part/item to be checked, but which are not reasonably accessible on the Vehicle, will not be inspected. In such circumstances, We will be under no obligation to inspect and/or report on the part/item in question and the Inspector will mark the relevant section of the Report accordingly.',
      'The vehicle should be reasonably clean to ensure that the Inspector can clearly see and accurately report on the relevant vehicle parts inspected. Where the vehicle is not clean, the Inspector reserves the right not to comment on those parts and will mark the Report Checklist accordingly. In such case, the Report Fee shall be fully payable.',
    ],
    subHeader1: 'Exclusions',
    subTitle: 'The items We do not check are:',
    listExcluded: [
      'Any parts which require dismantling/ removing/ disconnecting or taking apart for inspection purposes',
      'Vehicle data checks',
      'Oil and fuel consumption',
      'Source of oil leaks',
      'Brake lining material (other than what is immediately visible and can be seen without dismantling anything)',
      'Brake fluid for contamination. Brake fluid will deteriorate over a period of time and We advise that it be replaced as recommended by the Vehicle manufacturer',
      'Operation of cassette, compact-disc players, TV/DVD/satellite navigation systems, Bluetooth or other in-car entertainment',
      'Sound or radio reception and alarm systems',
      'Cylinder compression, vehicle electrics and electronics which would require specific diagnostic equipment',
      'Exhaust emissions and/or catalytic converters. If this is assessed by the Inspector as passing the Inspection it only relates to confirming its external condition, gas tightness and security. The Inspector is unable to confirm its internal condition or effectiveness as this requires exhaust emission testing which is not included in the Inspection',
      'The accuracy of in-car computer systems (for example, but in no way restricted to, computers used for route finding, fuel efficiency or otherwise)',
      'Exhaust emissions',
      'Air conditioning functions and efficiency',
      'The habitation area of Motorhomes - The electrical systems and appliances, water fittings and appliances, and the gas fitting and appliances are not checked. These are beyond the scope of the Inspection. It is strongly advised that these are tested and checked by a suitably qualified person prior to purchase',
      'Vehicle Technical Systems - Many vehicles are fitted or equipped with automatic or computerised operating systems, which may be controlled by microprocessors. These include engine-management systems, fuel systems, ignition systems, air- conditioning systems, lambda-controlled systems, stereo radio, cassettes, amplifiers, compact discs (single and multi), TV/DVD, satellite navigation, active and self- levelling suspensions, gearboxes, turbo-chargers and superchargers, anti-lock braking systems, four-wheel drive and electronic lockable differential units, traction control, alarm and immobiliser systems, catalytic exhaust systems, and variable camshaft timing systems.',
      'Within the scope of the Inspection it is not possible to check fully the detailed operation of these systems due to the many variations in features and operating modes, and it is not possible to confirm that these systems are functioning fully to the manufacturers design specifications. As a result, the Inspector is unable to confirm the detailed operation of any of these systems other than giving an overall view and opinion on the performances generally inspected or checked. Therefore, We cannot be held in any way liable to You for failing to identify any malfunction or failure of any of these systems to perform to the specification as designed by the manufacturer',
      'Non-standard accessories as a result of personal modifications or otherwise',
    ],
    subheader2: (
      <p>
        Furthermore, <strong>the Inspection cannot: </strong>
      </p>
    ),
    inspectionCannotListItems: [
      'a) confirm whether or not the passenger or luggage compartments (including the <br /> &nbsp;body or caravan area of any Motorhome) are watertight',
      'b) predict the life expectancy of exhaust systems, clutches or dual-mass flywheels',
      'c) provide any indication of any faults which might have become apparent had the Vehicle been driven in excess of the speed reached or the distance travelled during any road test carried out by the Inspector',
      'd) confirm that all or any of the components of the Vehicle are original components, or replacement components that have been manufactured by the manufacturer of the vehicle',
      'e) include the inspection of any parts, components or areas of the Vehicle that are not reasonably visible or accessible to the Inspector at the time of the Inspection',
      'f) confirm authenticity of the Vehicle’s Registration Document, the mileage, the Excise Licence, the Vehicle Identification Number (VIN), the Engine Number, the Registered Number or the Vehicle service history',
      'g) check for any recall notices. Wisedrive recommends that You check with the RTO or manufacturer that the Vehicle has not been subject to such notices.',
    ],
    listContent1: [
      <>
        <strong>The Inspection can only </strong>describe and/or identify
        defects actually found and/or which are reasonably capable of being
        found upon an external visual examination of the Vehicle at the time of
        Inspection. We cannot be held liable and are not responsible for any
        latent defects which are later discovered unless We can reasonably have
        been expected to see them during an Inspection conducted within the
        parameters of these terms and conditions. We cannot advise of defects if
        We cannot see them, or they are not apparent during the Inspection of
        the Vehicle concerned. In particular, please note that (without limiting
        the foregoing) Vehicles over 5 years old, those that have a high mileage
        and/or have been subjected to abnormal use may have latent defects.
        While such defects may, in appropriate circumstances, give rise to a
        claim against the seller of the Vehicle, they fall outside the scope of
        the Inspection and the Report is provided on this basis. Neither
        Wisedrive nor the Inspector will have any liability to You as a result
        of such defects.
      </>,
      <>
        <strong>Please note </strong>that used vehicles may contain serious
        internal, structural or mechanical defects and/or hidden corrosion,
        which will not be detectable from an external, visual examination. These
        vehicles may prove to be less reliable and may need more frequent
        repairs/servicing than more modern vehicles. While Our Inspectors take
        care to identify potential problems with the Vehicle from their external
        visual examination, You accept these and other disadvantages in owning a
        used vehicle and You accept that neither Wisedrive nor the Inspector
        will have any liability to You as a result of such defects.
      </>,
      'If there is no documentary evidence of a recent engine timing belt (cam belt) replacement, We recommend that the belt of the Vehicle is checked or replaced prior to purchase.',
      'If the Vehicle does not have a recent service history or it was not available to the Inspector at the time of the Inspection, then We recommend that a service in accordance with the Vehicle manufacturer&rsquo;s specifications be undertaken prior to purchase. This may highlight other defects, giving rise to repairs, which were not apparent from the external visual examination undertaken by the Inspector.',
      <>
        <strong>Please note </strong>that the life expectancy of an exhaust or
        clutch system is uncertain and difficult to predict. The fact that such
        items have not been identified as faulty on the Report does not and
        should not be taken to imply that such systems will have a continuing
        life expectancy from the time of Our check.
      </>,
    ],
    subHeader3: (
      <>
        <strong>Road Testing </strong>
      </>
    ),
    listContent2: [
      <>
        In order for our Inspectors to carry out a Road Test on the Vehicle, You
        must ensure that the vehicle contains sufficient:
        <br /> (a) Water; <br /> (b) Oil;
        <br /> (c ) Petrol.
      </>,
      'Road testing is carried out within the immediate area of the Inspection. If:',
      'The Vehicle is an unroadworthy condition or the Vehicle contains insufficient oil, water and/or petrol',
      'The Customer is unable to confirm that the Vehicle has a valid fitness certificate and therefore a road test cannot be carried out at the time of Inspection',
      'The Fee for the Inspection shall remain fully payable and an additional Fee will be payable for any subsequent road test You ask Us to undertake.',
      'The carrying out of a road test does not mean that Our Inspector has seen a valid fitness certificate. Obtaining necessary permissions, access to Vehicle etc',
      'It is the Customer’s responsibility to, and the Customer must, ensure that proper provision is made (including the obtaining of any necessary permission from the owner of the Vehicle) for the Inspection to be carried out on garage premises or on an off-road site with an adequate level, hard, dry standing area. Our Inspector needs enough room to be able to walk round the Vehicle and fully open all doors. There must also be enough room for Our Inspector to park his own vehicle close to the Inspection site.',
      'Good quality indoor lighting or daylight (if the Vehicle is outside) must be provided in the location where the Inspection is carried out. We are unable to check Vehicles in poor light or darkness.',
    ],
    subHeader4: 'Fees and cancellations ',
    listContent3: [
      'The Fee must be paid during the time of booking the Inspection.',
      <>
        We reserve the right to refuse to carry out an Inspection or to issue a
        Report on any vehicle: the Inspector cannot reasonably access; or
        appears to the Inspector to be: <br /> (a) not of standard production
        (for example, but not limited to, kit cars); <br /> (b) modified or not
        in regular use (for example, which show signs of excessive corrosion on
        moving parts associated with being left standing and which may result in
        the Vehicle being unsafe to drive without rectification); <br /> (c)
        un-roadworthy or unsafe to drive
      </>,
      'Any of the circumstances referred to in these T&C',
      'Where the Customer has failed to ensure that the proper provision has been made for the Inspection to be carried out, as required',
      'Where the Customer has provided incorrect or incomplete information that has prevented Us from carrying out an Inspection and You acknowledge that in such circumstances We are entitled to treat the Agreement as terminated and to retain the Fee in full. If You wish Us to carry out a further Inspection, You will be required to pay a further Fee at the time of booking.',
      'You have the right to cancel an Inspection and receive a full refund of the Fee, 24hrs before the inspection is scheduled. Once the inspection is carried out no refund will be issued.',
      'To cancel an Inspection, You must inform Our Service Support Team of your decision to cancel by emailing Support.in@wisedrive.com or by calling 7353 34 35 36, Monday to Friday 9am to 5pm. To enable us to find Your order, you will need to provide Your name, address, telephone number and booking reference (as provided with your booking confirmation) together with Your cancellation request.',
    ],
    subHeader5: 'Complaints',
    listContent4: [
      'If You have a complaint or are dissatisfied with any Inspection carried out, please contact Us on 73533 334 35 36 as soon as possible. We may need to re-inspect the Vehicle to deal with the complaint and You agree to allow Us to do so.',
      'No repairs should be effected or any parts replaced on the Vehicle which is the subject of a complaint before the Vehicle has been re-inspected by Us. Should emergency repairs be required to make the Vehicle safe and which is then later to be the subject of a complaint to Us, then You must ensure that a complaint is made to Us (including notification of the need to carry out emergency repairs) within a reasonable time after discovering the problem, and that any faulty or worn parts which are repaired or replaced are retained for future re-examination by Us. We will not, under any circumstances, be responsible for the cost of any repairs carried out or parts replaced without Our previous agreement in writing.',
      'We reserve the right to require another of Our Inspectors to re-inspect any Vehicle at Our own expense should it be considered necessary by Us to deal with any complaint and You are required to allow Our inspector to do so in accordance with these terms and conditions. We will provide an unbiased second opinion on the initial Report issued.',
    ],
    subHeader6: 'Matters outside of Our reasonable control',
    listContent5: [
      'We will not be liable for delay to/non-performance of the Inspection due to events or circumstances outside Our reasonable control. We will take steps to minimise the effects of this where possible.',
      'Wisedrive will only be liable to the Customer (and not to any other person) to the extent that Wisedrive fails to carry out the Inspection in accordance with these terms and conditions. Without limiting the foregoing, You acknowledge that neither Wisedrive or the Inspector will be liable to You or any other person for any liability, loss, damage, claim, proceedings, costs or expenses (together referred to as “Losses”) suffered or incurred by any circumstances where:',
      'such Losses are not a reasonably foreseeable result of any such breach (Losses are foreseeable where they could be contemplated by You and Us at the time the Vehicle is inspected)',
      'such Losses were not caused directly by a breach by Us or the Inspector of these terms and conditions',
      'such Losses comprise business losses or other losses to customers who are not consumers',
      'such Losses increase as a result of a breach by You of any of these terms and conditions.',
      'Nothing herein will affect the statutory rights of a consumer under any applicable statute.',
    ],
    subHeader7: 'Enforcement of terms',
    listContent6: [
      'Each of the clauses of these terms operates separately. If any court of relevant authority decides that any of them are unlawful, the remaining clauses will remain in full force and effect.',
      'The Agreement is between You and Wisedrive. No other person shall have any rights to enforce any of its terms. Neither of us will need to get the agreement of any person in order to make any changes to these terms.',
    ],
    subHeader8: 'Report advice',
    listContent7: [
      'You are strongly advised to discuss the findings within the Report with the seller prior to making any decision to purchase the Vehicle. If You have not viewed the Vehicle personally, You must ensure that the Vehicle’s cosmetic appearance and specification is satisfactory and suitable for your needs and expectations. We suggest You do so by viewing and driving the Vehicle yourself, prior to making your purchasing decision.',
    ],
  },
  aiComponent: {
    header:
      'Increasing Trust and transprancy in used car inspection with AI/ML',
    description:
      'Wisedrive uses sophisticated algorithms to detect, classify, and interpret engine noise patterns. This technology helps identify issues such as misfires, irregular vibrations, or wear and tear, enabling proactive maintenance. It ensures improved engine performance, reliability, and operational efficiency.',
    cardData: [
      {
        header: '20x',
        subtitle: 'More Accurate Engine Analysis',
        description:
          'Our AI trained with a million + engine sounds has higher accurate engine analysis and issues related to it.',
      },
      {
        header: '95%',
        subtitle: 'Minimizing Human Errors',
        description:
          'Our inspections decrease human interference and inscreases report quality using AI and ML.',
      },
      {
        header: '75%',
        subtitle: 'Reduced Inspection Time.',
        description:
          'Our technology ensures 75% decrease in inspection time and delivery of inspection report time is done in less than 30 min.',
      },
      {
        header: '99.99%',
        subtitle: 'Inspection Quality assurance',
        description:
          'Our AI provides 99.99% inspection quality accuracy with advanced sound analytics and engine analysis using OBD2 scanners.',
      },
    ],
  },
  cancellationAndRefund: {
    header: 'CANCELLATION AND REFUND POLICY',
    dataArray: [
      {
        subHeader: '1. DURING INITIAL 10 DAYS PERIOD',
        description:
          'Every Warranty policy holder / Dealers who has purchased extended warranty policy from Wisedrive Technologies Private Limited may request the cancellation of the policy and full refund thereof on or before the expiry of 10 (ten) calendar days from the date of receipt of Warranty policy premium amount. The Warranty Holder /Dealers shall place such policy cancellation and refund request by way of writing an email to Wisedrive Technologies Private Limited on support.in@wisedrive.com (“Cancellation Request”). Upon receipt of such Cancellation Request within above mentioned period, the Warranty policy will be cancelled by Wisedrive Technologies Private Limited and the entire policy amount paid by the Warranty Policy Holder /Dealers will be refunded. It is hereby clarified that, the Warranty and all the rights under the Warranty Policy shall stand terminated and extinguished immediately from the date of the Cancellation Request. No claims shall be entertained by Wisedrive Technologies Private Limited from the Warranty Policy Holder/Dealers from the date of the Cancellation Request.',
      },
      {
        subHeader: '2. CANCELLATION REQUEST RECEIVED AFTER INITIAL 10 DAYS',
        description:
          'The Warranty Policy Holders are entitled to receipt of refund upon cancellation of the Warranty policy within 10 days from the receipt of premium only. The Warranty Policy Holder shall have the right to place a policy cancellation request after above mentioned days, however for any such Cancellation Request received from the Warranty Policy Holder , no refunds will be processed by Wisedrive Technologies Private Limited.',
      },
      {
        subHeader: '3. PAYMENT AND MODE OF REFUND',
        description:
          'For the Cancellation Requests made within 10 days of payment, refund will be made within 14 (fourteen) business days from the date of receipt of the Cancellation Request. Such refund will be processed through the original mode of payment i.e. to the payment mode used initially by the Warrant Policy Holder or Wisedrive Technologies Private Limited may at its discretion process the refund through any other mode upon receipt of specific instruction from the Warranty Policy Holder along with the requisite details in the respective Cancellation Request.',
      },
    ],
  },
  privacyData: {
    header: 'Wisedrive technologies private limited privacy policy',
    contentArray: [
      {
        subHeader: 'What do we do with your information?',
        subContent:
          'When you purchase something from our store, as part of the buying and selling process, we collect the personal information you give us such as your name, address and email address. When you browse our store, we also automatically receive your computer’s internet protocol (IP) address in order to provide us with information that helps us learn about your browser and operating system. Email marketing (if applicable): With your permission, we may send you emails about our store, new products and other updates.',
      },
      {
        subHeader: 'Consent',
        subContent:
          'How do you get my consent? When you provide us with personal information to complete a transaction, verify your credit card, place an order, arrange for a delivery or return a purchase, we imply that you consent to our collecting it and using it for that specific reason only. If we ask for your personal information for a secondary reason, like marketing, we will either ask you directly for your expressed consent, or provide you with an opportunity to say no. How do I withdraw my consent? If after you opt-in, you change your mind, you may withdraw your consent for us to contact you, for the continued collection, use or disclosure of your information, at anytime, by contacting us at support.in@wisedrive.com',
      },
      {
        subHeader: 'Disclosure',
        subContent:
          'We may disclose your personal information if we are required by law to do so or if you violate our Terms of Service.',
      },
      {
        subHeader: 'Payment',
        subContent:
          'We use Razorpay for processing payments. We/Razorpay do not store your card data on their servers. The data is encrypted through the Payment Card Industry Data Security Standard (PCI-DSS) when processing payment. Your purchase transaction data is only used as long as is necessary to complete your purchase transaction. After that is complete, your purchase transaction information is not saved. Our payment gateway adheres to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, MasterCard, American Express and Discover. PCI-DSS requirements help ensure the secure handling of credit card information by our store and its service providers. For more insight, you may also want to read terms and conditions of razorpay.',
      },
      {
        subHeader: 'Third-party services',
        subContent:
          'In general, the third-party providers used by us will only collect, use and disclose your information to the extent necessary to allow them to perform the services they provide to us. However, certain third-party service providers, such as payment gateways and other payment transaction processors, have their own privacy policies in respect to the information we are required to provide to them for your purchase-related transactions. For these providers, we recommend that you read their privacy policies so you can understand the manner in which your personal information will be handled by these providers. In particular, remember that certain providers may be located in or have facilities that are located a different jurisdiction than either you or us. So if you elect to proceed with a transaction that involves the services of a third-party service provider, then your information may become subject to the laws of the jurisdiction(s) in which that service provider or its facilities are located. Once you leave our store’s website or are redirected to a third-party website or application, you are no longer governed by this Privacy Policy or our website’s Terms of Service. Links When you click on links on our store, they may direct you away from our site. We are not responsible for the privacy practices of other sites and encourage you to read their privacy statements.',
      },
      {
        subHeader: 'Security',
        subContent:
          'To protect your personal information, we take reasonable precautions and follow industry best practices to make sure it is not inappropriately lost, misused, accessed, disclosed, altered or destroyed.',
      },
      {
        subHeader: 'Cookies',
        subContent:
          'We use cookies to maintain session of your user. It is not used to personally identify you on other websites.',
      },
      {
        subHeader: 'Age of consent',
        subContent:
          'By using this site, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site.',
      },
      {
        subHeader: 'Changes to this privacy policy',
        subContent:
          'We reserve the right to modify this privacy policy at any time, so please review it frequently. Changes and clarifications will take effect immediately upon their posting on the website. If we make material changes to this policy, we will notify you here that it has been updated, so that you are aware of what information we collect, how we use it, and under what circumstances, if any, we use and/or disclose it. If our store is acquired or merged with another company, your information may be transferred to the new owners so that we may continue to sell products to you.',
      },
      {
        subHeader: 'Question & contact information',
        subContent:
          'If you would like to: access, correct, amend or delete any personal information we have about you, register a complaint, or simply want more information contact our Privacy Compliance Officer at support.in@wisedrive.com',
      },
    ],
  },
  reportData: {
    reportFor: 'Report for',
    inspectedBy: 'Inspected by',
    marketValue: 'Market Value',
    overallRating: 'Overall Rating',
    recommendedToBuy: 'Recommended to buy',
    inspectionDetailsTitle: 'Inspection Details',
    mechanicName: 'Mechanic Name',
    inspectionDate: 'Inspection Date',
    requestedDate: 'Requested Date',
    location: 'Location',
    inspectionSummaryTitle: 'Inspection Summary',
    checkpointsInspected: '200+ checkpoints inspected',
    assessmentTitle: 'Assessment',
    vehicleInformationTitle: 'Vehicle Information',
    make: 'Make',
    owners: 'Owners',
    model: 'Model',
    transmission: 'Transmission',
    year: 'Year',
    regNo: 'Reg. No',
    mfgDate: 'Mfg. Date',
    fuel: 'Fuel',
    colour: 'Colour',
    regDate: 'Reg. Date',
    engineCC: 'Engine CC',
    engineNumber: 'Engine No',
    chassisNo: 'Chassis No',
    keyInformation: 'Key Information',
    kmsDriven: 'KMS Driven',
    majorAccident: 'Accident',
    floodDamage: 'Flood Damage',
    engineCondition: 'Engine Condition',
    transmission: 'Transmission',
    exteriorCondition: 'Exterior Condition',
    interiorCondition: 'Interior Condition',
    dentsScratches: 'Dents & Scratches',
    avgTyreLife: 'Avg. Tyre Life',
    insurance: 'Insurance',
    majorRepair: 'Major Repair',
    minorRepair: 'Minor Repair',
    obd2ScanningReport: 'OBD2 Scanning Report',
    easy: 'Easy to Read',
    made: 'Made for easy understanding of every detail of your inspection report on mobile.',
    track: 'Easy to Track',
    trackMade:
      'Get complete details of post purchase expenses before buying the used car.',
    report: 'Comprehensive Report',
    good: 'Good',
    bad: 'Bad',
    average: 'Average',
    excellent: 'Excellent',
    yes: 'Yes',
    no: 'No',
    details: 'Details',
    estimate: 'Estimate',
    hideFaultCodes: 'Hide Fault Codes',
    showFaultCodes: 'View Fault Codes',
    checkPoints: 'Check Points',
    rating: 'Rating',
    errorsFound: 'errors found',
    showMore: 'Show More',
    showLess: 'Show Less',
    faults: 'Faults in',
    majorRepairEstimate: 'Major Repairs Estimate',
    minorRepairEstimate: 'Minor Repairs Estimate',
    noEstimate: 'No estimates available.',
    dentsDetails: 'Dent Details',
    tyreLifeDetails: 'Tyre Life Details',
    noTyreLife: 'No tyre life data available.',
    majorAccidentInfo: 'Accident Information',
    majorBasic:
      "Based on physical inspection, the mechanic didn't find any evidence of an accident. For further information, please contact the authorized service center or insurance provider.",
    valid: 'Valid',
    expired: 'Expired',
    notAvailable: 'Not Available',
    insuranceDetails: 'Insurance Details',
    insurer: 'Insurer',
    policyNumber: 'Policy Number',
    expiryDate: 'Expiry Date',
    expiresIn: 'Expires In (days)',
    reportMade:
      'This report is generated using Physical Inspection, AI, OBD2 Scanning using the latest scanning tools.',
    dec1Content:
      'K No-661/3-1114/3,4,5, 3rd Floor, No.46/4, Novel Tech Park, G B Palya, Bangalore, Karnataka - 560068',
  },
};
